import React from 'react';
import { Diagram } from '../diagram';
import './nwDiagram.scss';
import connections from "./NWconnections";

export class NWDiagram extends Diagram {
	parseConnectionData() {
		this.setState({ allConnections: connections });
	}

    render() {
        const G = this.G;
        const style1 = { strokeLinecap:"round", strokeLinejoin:"round", fill:"none" };

        return (
            <div className='container nw-diagram'>



<svg xmlns="http://www.w3.org/2000/svg"  
		 width="24.5in" height="21.5in" viewBox="0 0 1764 1548"
		 colorInterpolationFilters="sRGB" className="st84">
	
		
			
			
			
		
	

	<style type="text/css">
	
	</style>

	<defs id="Markers">
		<G id="lend25">
			<path d="M 1.5 -0.75 L 1.5 0.75 M 2.25 -0.75 L 2.25 0.75 " style={style1}/>
		</G>
		<marker id="mrkr25-246" className="st20" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-248" className="st20" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-258" className="st23" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-260" className="st23" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-312" className="st26" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-314" className="st26" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<G id="lend28">
			<path d="M 0 -0.75 L 1.5 0 L 0 0.75 M 2 -0.75 L 2 0.75 " style={style1}/>
		</G>
		<marker id="mrkr28-324" className="st26" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-331" className="st30" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr28-333" className="st30" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-344" className="st33" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-346" className="st33" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-356" className="st36" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<G id="lend29">
			<path
					d="M 2.25 0.75 C 1.83579 0.75 1.5 0.414214 1.5 0 1.5 -0.414214 1.83579 -0.75 2.25 -0.75 2.66421 -0.75 3 -0.414214 3 0 3 0.414214 2.66421 0.75 2.25 0.75 Z M 0 -0.75 L 1.5 0 L 0 0.75 M 1.5 0 L 0 0 "
					style={style1}/>
		</G>
		<marker id="mrkr29-358" className="st36" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-370" className="st33" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-590" className="st20" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-609" className="st23" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-697" className="st30" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-718" className="st36" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr25-754" className="st52" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-756" className="st52" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-769" className="st52" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-790" className="st57" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-839" className="st33" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-888" className="st61" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-890" className="st61" arrowtype="29" arrowsize="2" setback="8.04" refX="-8.04" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-896" className="st61" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-970" className="st36" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr29-1057" className="st30" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
		<marker id="mrkr25-1059" className="st30" arrowtype="25" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend25" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr28-1179" className="st79" arrowtype="28" arrowsize="4" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(6.5) "/>
		</marker>
		<marker id="mrkr29-1181" className="st79" arrowtype="29" arrowsize="4" setback="19.5" refX="-19.5" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(-6.5,-6.5) "/>
		</marker>
		<marker id="mrkr28-1282" className="st36" arrowtype="28" arrowsize="2" orient="auto" markerUnits="strokeWidth"
				overflow="visible">
			<use href="#lend28" transform="scale(-2.68,-2.68) "/>
		</marker>
		<marker id="mrkr29-1304" className="st61" arrowtype="29" arrowsize="2" setback="7.8" refX="7.8" orient="auto"
				markerUnits="strokeWidth" overflow="visible">
			<use href="#lend29" transform="scale(2.68) "/>
		</marker>
	</defs>
	<defs id="Filters">
		<filter id="filter_2">
			<feGaussianBlur stdDeviation="2"/>
		</filter>
	</defs>
	<G mid="9" index="1" groupcontext="foregroundPage">
		
			
		
		<title></title>
		
		
		
		
		
		
		
		
		
		
		<G id="shape1227-1" mid="1227" groupcontext="shape" layermember="0" transform="translate(481.5,-921.375)">
			<title></title>
			
				
			
			<G id="shadow1227-2" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1319.63" width="328.5" height="228.375" className="st2"/>
			</G>
			<rect x="0" y="1319.63" width="328.5" height="228.375" className="st3"/>
		</G>
		<G id="group1194-6" transform="translate(1408.51,-783.138)" mid="1194" groupcontext="group" layermember="0">
			<title></title>
			<G id="shape1195-7" mid="1195" groupcontext="shape" layermember="0" transform="translate(0,-95.9667)">
				<title></title>
				<G id="shadow1195-8" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
						transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st4"/>
			</G>
			<G id="shape1196-12" mid="1196" groupcontext="shape" layermember="0" transform="translate(0,-72.5105)">
				<title></title>
				<G id="shadow1196-13" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st5"/>
			</G>
			<G id="shape1197-17" mid="1197" groupcontext="shape" layermember="0" transform="translate(0,-27.1793)">
				<title></title>
				<G id="shadow1197-18" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st6"/>
			</G>
			<G id="shape1198-22" mid="1198" groupcontext="shape" layermember="0" transform="translate(0.401161,-119.405)">
				<title></title>
				<G id="shadow1198-23" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st7"/>
			</G>
			<G id="shape1199-27" mid="1199" groupcontext="shape" layermember="0" transform="translate(0.0486256,-4.58053)">
				<title></title>
				<G id="shadow1199-28" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st8"/>
			</G>
			<G id="shape1200-32" mid="1200" groupcontext="shape" layermember="0" transform="translate(0,-48.4408)">
				<title></title>
				<G id="shadow1200-33" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="57" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="57" height="14.0406" className="st9"/>
			</G>
			<G id="shape1201-37" mid="1201" groupcontext="shape" layermember="0" transform="translate(0.757749,-141.186)">
				<title></title>
				<G id="shadow1201-38" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279"
						shadowtype="1" transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
					<rect x="0" y="1533.96" width="55.4363" height="14.0406" className="st2"/>
				</G>
				<rect x="0" y="1533.96" width="55.4363" height="14.0406" className="st10"/>
			</G>
			<G id="shape1202-42" mid="1202" groupcontext="shape" layermember="0" transform="translate(58.4857,-24.5272)">
				<title></title>
				<desc>Energy and services</desc>
				
				
				<rect x="0" y="1533.08" width="105.305" height="14.9182" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.14" className="st12" langid="1033">Energy and services</text>			</G>
			<G id="shape1203-45" mid="1203" groupcontext="shape" layermember="0" transform="translate(58.4857,-3.44537)">
				<title></title>
				<desc>Control and coordination</desc>
				
				
				<rect x="0" y="1533.08" width="169.896" height="14.9182" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.14" className="st12" langid="1033">Control and coordination</text>			</G>
			<G id="shape1204-48" mid="1204" groupcontext="shape" layermember="0" transform="translate(58.4857,-48.4454)">
				<title></title>
				<desc>State regulation</desc>
				
				
				<rect x="0" y="1533.08" width="132.75" height="14.9182" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.14" className="st12" langid="1033">State regulation</text>			</G>
			<G id="shape1205-51" mid="1205" groupcontext="shape" layermember="0" transform="translate(58.4857,-72.4863)">
				<title></title>
				<desc>Federal regulation</desc>
				
				
				<rect x="0" y="1533.08" width="105.305" height="14.9182" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.14" className="st12" langid="1033">Federal regulation</text>			</G>
			<G id="shape1206-54" mid="1206" groupcontext="shape" layermember="0" transform="translate(58.4857,-93.5067)">
				<title></title>
				<desc>Retail</desc>
				
				
				<rect x="0" y="1533.63" width="49.7273" height="14.375" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.41" className="st12" langid="1033">Retail</text>			</G>
			<G id="shape1207-57" mid="1207" groupcontext="shape" layermember="0" transform="translate(58.4857,-118.966)">
				<title></title>
				<desc>Market interaction</desc>
				
				
				<rect x="0" y="1533.08" width="122.938" height="14.9182" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1544.14" className="st12" langid="1033">Market interaction</text>			</G>
			<G id="shape1208-60" mid="1208" groupcontext="shape" layermember="0" transform="translate(58.4857,-137.036)">
				<title></title>
				<desc>Reliability coordination</desc>
				
				
				<rect x="0" y="1526.43" width="132.75" height="21.5678" className="st11" style={{fill: 'inherit'}} />
				<text x="4" y="1540.82" className="st12" langid="1033">Reliability coordination</text>			</G>
		</G>
		<G id="shape1209-63" mid="1209" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1404,-782.438)">
			<title></title>
			<G id="shadow1209-64" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1384.88" width="232.896" height="163.125" className="st13"/>
			</G>
			<rect x="0" y="1384.88" width="232.896" height="163.125" className="st14"/>
		</G>
		<G id="shape1217-68" mid="1217" groupcontext="shape" layermember="0" transform="translate(261,-972)" label="Federal Regulators" description="The Federal Regulators entity class primarily consists of the Federal Energy Regulatory Commission (FERC), Environmental Protection Agency (EPA), Nuclear Regulatory Commission (NRC), Department of Energy (DOE), and Commodity Futures Trading Commission (CFTC). FERC is an independent agency within the U.S. Department of Energy (DOE) which has regulatory authority over interstate transmission. It regulates sales of wholesale electricity in interstate commerce, as well as provides oversight of regional wholesale markets. It also establishes financial rules for all entities of the bulk power system, such as the firewall rules between financial activities and transmission system operations. Other responsibilities include licensing and inspecting hydroelectric projects and overseeing environmental matters related to them and protecting reliability of high voltage interstate transmission by enforcing reliability standards. " >
			<title>Federal Regulators</title>
			<desc>Federal Regulators</desc>
			
				
			
			
			
			<G id="shadow1217-69" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="27.99" y="1517.4" className="st15" langid="1033">Federal <tspan
							x="19.31" dy="1.2em" className="st16">Regulators</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="27.99" y="1517.4" className="st18" langid="1033">Federal <tspan
						x="19.31" dy="1.2em" className="st16">Regulators</tspan></text>		</G>
		<G id="shape1218-78" mid="1218" groupcontext="shape" layermember="0" transform="translate(81,-972)" label="Federal Legislature" description="Federal legislatures define the scope of the various regulatory entities at the federal level. They may also define incentives for investment or other action within the industry and by consumers." >
			<title>Federal Legislature</title>
			<desc>Federal Legislature</desc>
			
				
			
			
			
			<G id="shadow1218-79" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="27.99" y="1517.4" className="st15" langid="1033">Federal <tspan
							x="18.98" dy="1.2em" className="st16">Legislature</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="27.99" y="1517.4" className="st18" langid="1033">Federal <tspan
						x="18.98" dy="1.2em" className="st16">Legislature</tspan></text>		</G>
		<G id="shape1219-88" mid="1219" groupcontext="shape" layermember="0" transform="translate(266.67,-864)" label="State Regulators" description="In the U.S., regulatory commissions have been established by the 50 states and the District of Columbia for overseeing the operations and transactions of electric energy in their jurisdiction. These commissions may take different names like Public Utility Commissions (PUC), Public Service Commissions (PSC), corporation commissions, or commerce commissions. Areas which are considered outside of FERC's jurisdictional responsibility, for example retail electricity sales or regulation of distribution facilities, are regulated by the state regulators. " >
			<title>State Regulators</title>
			<desc>State Regulators</desc>
			
				
			
			
			
			<G id="shadow1219-89" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="34.32" y="1517.4" className="st15" langid="1033">State <tspan
							x="19.31" dy="1.2em" className="st16">Regulators</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="34.32" y="1517.4" className="st18" langid="1033">State <tspan
						x="19.31" dy="1.2em" className="st16">Regulators</tspan></text>		</G>
		<G id="shape1220-98" mid="1220" groupcontext="shape" layermember="0" transform="translate(72,-864)" label="State Legislature" description="State legislatures play one of the key roles in developing policies, providing recommendations, or in some other cases signaling support or opposition to certain policies and initiatives, and also urging federal action if needed. They can provide funding, incentives or mandates for advancing grid technologies. For example, state legislature may establish incentives or renewable portfolio standards that apply to all utilities within the state. They establish the regulatory construct for Investor Owned Utilities (IOUs), and sometimes other utilities, within their state, which is then applied by the state-level utility regulatory body." >
			<title>State Legislature</title>
			<desc>State Legislature</desc>
			
				
			
			
			
			<G id="shadow1220-99" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="34.32" y="1517.4" className="st15" langid="1033">State <tspan
							x="18.98" dy="1.2em" className="st16">Legislature</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="34.32" y="1517.4" className="st18" langid="1033">State <tspan
						x="18.98" dy="1.2em" className="st16">Legislature</tspan></text>		</G>
		<G id="shape1221-108" mid="1221" groupcontext="shape" layermember="0" transform="translate(72,-756)" label="NERC" description="The North American Electric Reliability Corporation (NERC) is a not-for-profit international regulatory authority tasked with assuring reliability and security of the bulk power system in North America. NERC's area of responsibility covers the continental U.S., Canada as well as the northern portion of Baja California, Mexico. Currently, NERC is designated as the U.S. government's Electric Reliability Organization (ERO) subject to oversight by the FERC. Some of the responsibilities of NERC include development and enforcement of reliability standards, annual assessment of reliability, monitoring of bulk power system as well as education, training and certification of industry personnel. 
Reference:
NERC, &quot;About NERC&quot;, 2017, [Online]. Available: https://www.nerc.com/AboutNERC/Pages/default.aspx. [Accessed: 06-Jan-2020]." >
			<title>North American Electric Reliability Corporation</title>
			<desc>NERC</desc>
			
				
			
			
			
			<G id="shadow1221-109" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="31.33" y="1524.6" className="st15" langid="1033">NERC</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="31.33" y="1524.6" className="st18" langid="1033">NERC</text>		</G>
		<G id="shape1222-116" mid="1222" groupcontext="shape" layermember="0" transform="translate(261,-756)" label="Reliability Coordinator" description="Reliability coordinator (RC) ensures wide-area reliability by developing and monitoring all reliability-related parameters, performing reliability analysis, and directing necessary actions. It also directs and coordinates emergency services and system restorative operations. An RC receives facility and operational data from Generator Owners (GO), Generator Operators (GOP), Transmission Owners (TO), Transmission Operators (TOP) and Load Serving Entities (LSE) ahead of time. It receives generation dispatch information and integrated operational plans from Balancing Authorities (BA), and final decision on arranged interchange from the Interchange Coordinator (IC), all ahead of time. In the real-time it receives operational information from IC, BA and TOP. Based on its reliability analyses RC issues reliability alerts to GOP, TOP, Transmission Service Provider (TSP), BA, IC, Regional Reliability Entity and NERC in real-time. It also issues corrective actions and emergency procedure directives to TOP, BA, GOP, IC, and Distribution Provider (DP)." >
			<title>Reliability Coordinator</title>
			<desc>Reliability Coordinator</desc>
			
				
			
			
			
			<G id="shadow1222-117" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="22.65" y="1517.4" className="st15" langid="1033">Reliability <tspan
							x="16.98" dy="1.2em" className="st16">Coordinator</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="22.65" y="1517.4" className="st18" langid="1033">Reliability <tspan
						x="16.98" dy="1.2em" className="st16">Coordinator</tspan></text>		</G>
		<G id="shape1223-126" mid="1223" groupcontext="shape" layermember="0" transform="translate(81,-1116)" label="NPCC" description="In 1980, Congress passed the Northwest Power Act, authorizing the states of Idaho, Montana, Oregon, and Washington to form the Council, an interstate compact for planning the energy future and managing the natural resources in the Columbia River Basin. The Act requires the Council to develop, with broad citizen participation, a regional power plan, and fish and wildlife program. The Council develops a 20-year plan, which it revises every five years, to ensure the Northwest of an efficient and reliable power supply. Wholesale power revenues from the Bonneville Power Administration fund the Council. 
Reference:
NPCC, &quot;2019 Overview&quot;, 2019 [Online]. Available: https://www.nwcouncil.org/sites/default/files/2019Overview.pdf. [Accessed: 06-Jan-2020]." >
			<title>Northwest Power and Conservation Council</title>
			<desc>NPCC</desc>
			
				
			
			
			
			<G id="shadow1223-127" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="31.33" y="1524.6" className="st15" langid="1033">NPCC</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="31.33" y="1524.6" className="st18" langid="1033">NPCC</text>		</G>
		<G id="shape1224-134" mid="1224" groupcontext="shape" layermember="0" transform="translate(597.42,-1188.25)" label="BPA Power Marketing Administration" description="Power Market Administrations (PMA), interchangeably called Power Marketing Agencies, are officially federal agencies within the Department of Energy which market wholesale power produced by federally owned and operated hydroelectric dams. " >
			<title>BPA Power Marketing Administration</title>
			<desc>BPA Power Marketing Administration</desc>
			
				
			
			
			
			<G id="shadow1224-135" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="17.65" y="1510.2" className="st15" langid="1033">BPA Power <tspan
							x="21.99" dy="1.2em" className="st16">Marketing </tspan><tspan x="10.31" dy="1.2em" className="st16">Administration</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="17.65" y="1510.2" className="st18" langid="1033">BPA Power <tspan
						x="21.99" dy="1.2em" className="st16">Marketing </tspan><tspan x="10.31" dy="1.2em" className="st16">Administration</tspan></text>		</G>
		<G id="shape1225-146" mid="1225" groupcontext="shape" layermember="0" transform="translate(687.33,-936)" label="BPA Transmission Service Provider" description="As a Transmission Service Provider (TSP), BPA processes transmission service requests received from Generator Owners (GO), Load Serving Entities (LSE) and Purchase Selling Entities (PSE). The Transmission Owner's (TO's) tariff and the operating limits provided by the Reliability Coordinator (RC) are considered when processing such requests. A TSP also allocates transmission losses between the Balancing Aauthorities (BA) and arranges for transmission loss compensation. " >
			<title>BPA Transmission Service Provider</title>
			<desc>BPA Transmission Service Provider</desc>
			
				
			
			
			
			<G id="shadow1225-147" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="36.32" y="1510.2" className="st15" langid="1033">BPA <tspan
							x="12.65" dy="1.2em" className="st16">Transmission </tspan><tspan x="4.31" dy="1.2em" className="st16">Service Provider</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="36.32" y="1510.2" className="st18" langid="1033">BPA <tspan x="12.65"
						dy="1.2em" className="st16">Transmission </tspan><tspan x="4.31" dy="1.2em" className="st16">Service Provider</tspan></text>		</G>
		<G id="shape1226-158" mid="1226" groupcontext="shape" layermember="0" transform="translate(497.34,-936)" label="BPA Balancing Authority" description="As a Balancing Authority (BA), BPA is responsible for maintaining balance between generation, load, and interchange in real-time. Its contribution is critical to maintaining the desired interconnection frequency. On a high-level the tasks of a BA include controlling resources within its area, performing unit commitment (UC) and economic dispatch (ED), deploying regulation services as needed, approving and implementing interchange with adjoining balancing authorities, and providing planned schedules to the Reliability Coordinator (RC). During any emergency event, it works with the RC to implement emergency procedures like demand-side management programs, load shedding etc.   " >
			<title>BPA Balancing Authority</title>
			<desc>BPA Balancing Authority</desc>
			
				
			
			
			
			<G id="shadow1226-159" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="8.3" y="1517.4" className="st15" langid="1033">BPA Balancing <tspan
							x="24.65" dy="1.2em" className="st16">Authority</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="8.3" y="1517.4" className="st18" langid="1033">BPA Balancing <tspan
						x="24.65" dy="1.2em" className="st16">Authority</tspan></text>		</G>
		<G id="shape1233-168" mid="1233" groupcontext="shape" layermember="0" transform="translate(866.34,-983.25)" label="Other Transmission Owners" description="Transmission Owners (TO) other than BPA that own and maintain transmission facilities in the considered area. They provide maintenance and construction plans and schedules to the Reliability Coordinator (RC) and Transmission Operators (TOP), or revise them on their request. They also provide reactive resources to TOP." >
			<title>Other Transmission Owners</title>
			<desc>Other Transmission Owners</desc>
			
				
			
			
			
			<G id="shadow1233-169" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="33.32" y="1510.2" className="st15" langid="1033">Other <tspan
							x="12.65" dy="1.2em" className="st16">Transmission </tspan><tspan x="27.66" dy="1.2em" className="st16">Owners</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="33.32" y="1510.2" className="st18" langid="1033">Other <tspan
						x="12.65" dy="1.2em" className="st16">Transmission </tspan><tspan x="27.66" dy="1.2em" className="st16">Owners</tspan></text>		</G>
		<G id="shape1236-180" mid="1236" groupcontext="shape" layermember="0" transform="translate(675,-810)" label="Distribution Service Providers" description="An Entity class that owns or operates a distribution system for the delivery of energy from the transmission system to customers." >
			<title>Distribution Service Providers</title>
			<desc>Distribution Service Providers</desc>
			
				
			
			
			
			<G id="shadow1236-181" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="108" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="23.99" y="1517.4" className="st15" langid="1033">Distribution <tspan
							x="6.98" dy="1.2em" className="st16">Service Providers</tspan></text>			</G>
			<rect x="0" y="1494" width="108" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="23.99" y="1517.4" className="st18" langid="1033">Distribution <tspan
						x="6.98" dy="1.2em" className="st16">Service Providers</tspan></text>		</G>
		<G id="shape1240-190" mid="1240" groupcontext="shape" layermember="0" transform="translate(419.67,-648)" label="Direct Service Industries" description="Industrial customers, primarily aluminum smelters, that buy power directly from BPA at relatively high voltages. BPA signed long-term contracts with the Direct Service Industries in 1981, which expired in 2001. Since 2001, BPA has had varying contractual relationships with them. " >
			<title>Direct Service Industries</title>
			<desc>Direct Service Industries</desc>
			
				
			
			
			
			<G id="shadow1240-191" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="10.99" y="1517.4" className="st15" langid="1033">Direct Service <tspan
							x="22.32" dy="1.2em" className="st16">Industries</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="10.99" y="1517.4" className="st18" langid="1033">Direct Service <tspan
						x="22.32" dy="1.2em" className="st16">Industries</tspan></text>		</G>
		<G id="shape1241-200" mid="1241" groupcontext="shape" layermember="0" transform="translate(536.67,-486)" label="C and I Customers" description="The commercial sector includes retail, office, institutional, public and government facilities, and public services. Industrial customers, on the other hand, include manufacturing, mining, agriculture and construction industries." >
			<title>C and I Customers</title>
			<desc>C and I Customers</desc>
			
				
			
			
			
			<G id="shadow1241-201" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="28.98" y="1517.4" className="st15" langid="1033">C and I <tspan
							x="19.32" dy="1.2em" className="st16">Customers</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="28.98" y="1517.4" className="st18" langid="1033">C and I <tspan
						x="19.32" dy="1.2em" className="st16">Customers</tspan></text>		</G>
		<G id="shape1242-210" mid="1242" groupcontext="shape" layermember="0" transform="translate(774,-486)" label="Residential Customers" description="Residential customers include single-family homes and multi-family housing. " >
			<title>Residential Customers</title>
			<desc>Residential Customers</desc>
			
				
			
			
			
			<G id="shadow1242-211" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="18.65" y="1517.4" className="st15" langid="1033">Residential <tspan
							x="19.32" dy="1.2em" className="st16">Customers</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="18.65" y="1517.4" className="st18" langid="1033">Residential <tspan
						x="19.32" dy="1.2em" className="st16">Customers</tspan></text>		</G>
		<G id="shape1245-220" mid="1245" groupcontext="shape" layermember="0" transform="translate(1134,-621)" label="Energy Imbalance Market" description="The Western Energy Imbalance Market is a voluntary intra-hour centralized energy market used to economically and securely dispatch participating resources to efficiently balance supply, schedule transfers between participating Balancing Authority Areas (i.e. EIM Entity BAAs), and load across the market's footprint (EIM Area). It is operated by the California Independent System Operator (CAISO), and current active participants include CAISO, PacifiCorp, NV Energy, Arizona Public Service, Puget Sound Energy, Portland General Electric, Idaho Power and Powerex." >
			<title>Energy Imbalance Market</title>
			<desc>Energy Imbalance Market</desc>
			
				
			
			
			
			<G id="shadow1245-221" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="29.32" y="1510.2" className="st15" langid="1033">Energy <tspan
							x="20.65" dy="1.2em" className="st16">Imbalance </tspan><tspan x="29.99" dy="1.2em" className="st16">Market</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="29.32" y="1510.2" className="st18" langid="1033">Energy <tspan
						x="20.65" dy="1.2em" className="st16">Imbalance </tspan><tspan x="29.99" dy="1.2em" className="st16">Market</tspan></text>		</G>
		<G id="shape1246-232" mid="1246" groupcontext="shape" layermember="0" transform="translate(1139.67,-477)" label="CAISO" description="The California Independent System Operator (CAISO) is a non-profit Independent System Operator serving California. It oversees the operation of California's bulk electric power system, transmission lines, and electricity market generated and transmitted by its member utilities. CAISO's markets include energy (day-ahead and real-time), ancillary services, and congestion revenue rights. CAISO also operates the Western Energy Imbalance Market (EIM)." >
			<title>California Independent System Operator</title>
			<desc>CAISO</desc>
			
				
			
			
			
			<G id="shadow1246-233" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="29.66" y="1524.6" className="st15" langid="1033">CAISO</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="29.66" y="1524.6" className="st18" langid="1033">CAISO</text>		</G>
		<G id="shape1248-240" mid="1248" groupcontext="shape" layermember="1" transform="translate(177.66,-990)">
			<title></title>
			<path d="M0 1539 L83.34 1539" className="st19"/>
		</G>
		<G id="shape1249-249" mid="1249" groupcontext="shape" layermember="1" transform="translate(143.33,-999)">
			<title></title>
			<desc>directs &#62;</desc>
			
			
			<rect x="0" y="1528" width="152" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="55.16" y="1541.6" className="st21" langid="1033">directs &#62;</text>		</G>
		<G id="shape1250-252" mid="1250" groupcontext="shape" layermember="2" transform="translate(168.66,-882)">
			<title></title>
			<path d="M0 1539 L71.34 1539 A3 3 0 1 1 77.34 1539 L98.01 1539" className="st22"/>
		</G>
		<G id="shape1251-261" mid="1251" groupcontext="shape" layermember="2" transform="translate(162,-889)">
			<title></title>
			<desc>directs &#62;</desc>
			
			
			<rect x="0" y="1528" width="96.66" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="27.49" y="1541.6" className="st24" langid="1033">directs &#62;</text>		</G>
		<G id="shape1252-264" mid="1252" groupcontext="shape" layermember="1" transform="translate(277.11,-972)">
			<title></title>
			<path d="M0 1548 L-0 1575.43 L-34.11 1575.43 L-34.11 1723.5 L-108.45 1723.5" className="st19"/>
		</G>
		<G id="shape1253-271" mid="1253" groupcontext="shape" layermember="1" transform="translate(176,-944)">
			<title></title>
			<desc>&#60; directs</desc>
			
			
			<rect x="0" y="1528" width="152" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="55.16" y="1541.6" className="st21" langid="1033">&#60; directs</text>		</G>
		<G id="shape1254-274" mid="1254" groupcontext="shape" layermember="1" transform="translate(348.66,-985.5)">
			<title></title>
			<path d="M9 1548 L56.34 1548 L56.34 1737 L42.21 1737 A3 3 -180 0 0 36.21 1737 L9 1737" className="st19"/>
		</G>
		<G id="shape1255-281" mid="1255" groupcontext="shape" layermember="1" transform="translate(356.67,-922.5)">
			<title></title>
			<desc>&#60; oversight on compliance</desc>
			
			
			<rect x="0" y="1503" width="96.66" height="45" className="st11" style={{fill: 'inherit'}} />
			<text x="-1560.18" y="44.73" transform="rotate(-90)" className="st21" langid="1033">&#60; oversight on <tspan
						x="-1553.45" dy="1.2em" className="st16">compliance</tspan></text>		</G>
		<G id="shape1256-285" mid="1256" groupcontext="shape" layermember="1" transform="translate(357.66,-1008)">
			<title></title>
			<path d="M0 1557 L75.12 1557 A3 3 0 0 1 81.12 1557 L123.84 1557" className="st19"/>
		</G>
		<G id="shape1257-292" mid="1257" groupcontext="shape" layermember="1" transform="translate(326.66,-998)">
			<title></title>
			<desc>regulates &#62;</desc>
			
			
			<rect x="0" y="1528" width="152" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="49.01" y="1541.6" className="st21" langid="1033">regulates &#62;</text>		</G>
		<G id="shape1267-295" mid="1267" groupcontext="shape" layermember="1" transform="translate(177.66,-1129.5)">
			<title></title>
			<path d="M0 1548 L96.45 1548 A3 3 0 0 1 102.45 1548 L144.78 1548 A3 3 0 0 1 150.78 1548 L255.12 1548 A3 3 0 0 1 261.12
						 1548 L288 1548 L288 1584.84 L303.84 1584.84" className="st19"/>
		</G>
		<G id="shape1270-302" mid="1270" groupcontext="shape" layermember="1" transform="translate(317.34,-1116)">
			<title></title>
			<desc>sets priorities &#38; recommends &#62;</desc>
			
			
			<rect x="0" y="1518.12" width="96.66" height="29.8826" className="st11" style={{fill: 'inherit'}} />
			<text x="9.86" y="1529.46" className="st21" langid="1033">sets priorities &#38; <tspan
						x="11.98" dy="1.2em" className="st16">recommends </tspan>&#62;</text>		</G>
		<G id="shape1273-306" mid="1273" groupcontext="shape" layermember="6" transform="translate(357.66,-769.5)">
			<title></title>
			<path d="M0 1548 L27.21 1548 A3 3 0 0 1 33.21 1548 L57.29 1548 L57.29 1425.88 L75.12 1425.88 A3 3 0 0 1 81.12 1425.88
						 L178.59 1425.88 L178.59 1396.12" className="st25"/>
		</G>
		<G id="shape1274-315" mid="1274" groupcontext="shape" layermember="6" transform="translate(641.835,-876.059)">
			<title></title>
			<desc>coordinates reliability &#62;</desc>
			
			
			<rect x="0" y="1518.12" width="84.33" height="29.8826" className="st11" style={{fill: 'inherit'}} />
			<text x="13.31" y="1529.46" className="st27" langid="1033">coordinates <tspan
						x="15.11" dy="1.2em" className="st16">reliability </tspan>&#62;</text>		</G>
		<G id="shape1280-319" mid="1280" groupcontext="shape" layermember="6" transform="translate(535.551,-891.621)">
			<title></title>
			<path d="M0 1548 L7.12 1548 A3 3 0 0 1 13.12 1548 L39.34 1548 A3 3 0 0 1 45.34 1548 L73.45 1548 A3 3 0 0 1 79.45 1548
						 L90.32 1548 A3 3 0 1 1 96.32 1548 L193.45 1548 L193.45 1575.62" className="st28"/>
		</G>
		<G id="shape1295-325" mid="1295" groupcontext="shape" layermember="3" transform="translate(577.89,-936)">
			<title></title>
			<path d="M0 1548 L0 1764 L72.78 1764 A3 3 0 0 1 78.78 1764 L130.11 1764 A3 3 0 0 1 136.11 1764 L166.11 1764 A3 3 0 1
						 1 172.11 1764 L256.11 1764 A3 3 0 1 1 262.11 1764 L307.73 1764 A3 3 0 0 1 313.73 1764 L323.83 1764 A3 3
						 0 0 1 329.83 1764 L372.17 1764 A3 3 0 1 1 378.17 1764 L477.33 1764 A3 3 0 0 1 483.33 1764 L493.44 1764 A3
						 3 0 0 1 499.44 1764 L525.66 1764 A3 3 0 0 1 531.66 1764 L613.89 1764 L613.89 1643.14" className="st29"/>
		</G>
		<G id="shape1296-334" mid="1296" groupcontext="shape" layermember="3" transform="translate(1134,-772)">
			<title></title>
			<desc>&#60; coordinate power flow between BA&#62;</desc>
			
			
			<rect x="0" y="1528" width="117" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="-1587.25" y="54.9" transform="rotate(-90)" className="st31" langid="1033">&#60; coordinate  power <tspan
						x="-1582.66" dy="1.2em" className="st16">flow between BA</tspan>&#62;</text>		</G>
		<G id="shape1347-338" mid="1347" groupcontext="shape" layermember="5" transform="translate(1194.17,-531)">
			<title></title>
			<path d="M-6.17 1548 L-6.17 1470.48 L-11.84 1470.48 L-11.84 1458" className="st32"/>
		</G>
		<G id="shape1348-347" mid="1348" groupcontext="shape" layermember="5" transform="translate(1080,-566)">
			<title></title>
			<desc>operates &#62;</desc>
			
			
			<rect x="0" y="1528" width="198" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="-1563.95" y="102.6" transform="rotate(-90)" className="st34" langid="1033">operates &#62;</text>		</G>
		<G id="shape1351-350" mid="1351" groupcontext="shape" layermember="4" transform="translate(703.44,-1080)">
			<title></title>
			<path d="M0 1548 L0 1566 L-91.44 1566 L-91.44 1857 L-122.55 1857 A3 3 -180 0 0 -128.55 1857 L-154.77 1857 A3 3 -180 0
						 0 -160.77 1857 L-203.22 1857 L-203.22 1913.94" className="st35"/>
		</G>
		<G id="shape1354-359" mid="1354" groupcontext="shape" layermember="4" transform="translate(558,-816.117)">
			<title></title>
			<desc>&#60; transport bulk power to</desc>
			
			
			<rect x="0" y="1500.12" width="108" height="47.8826" className="st11" style={{fill: 'inherit'}} />
			<text x="-1563.06" y="50.4" transform="rotate(-90)" className="st37" langid="1033">&#60; transport bulk <tspan
						x="-1546.27" dy="1.2em" className="st16">power to</tspan></text>		</G>
		<G id="shape1373-363" mid="1373" groupcontext="shape" layermember="5" transform="translate(597.42,-1228.75)">
			<title></title>
			<path d="M0 1548 L-161.64 1548 L-161.64 2062.69" className="st38"/>
		</G>
		<G id="shape1374-371" mid="1374" groupcontext="shape" layermember="5" transform="translate(378,-1050.12)">
			<title></title>
			<desc>&#60; sell industrial firm &#38; secondary nonfirm power to</desc>
			
			
			<rect x="0" y="1518.12" width="126" height="29.8826" className="st11" style={{fill: 'inherit'}} />
			<text x="-1586.65" y="52.2" transform="rotate(-90)" className="st34" langid="1033">&#60; sell industrial firm &#38; <tspan
						x="-1579" dy="1.2em" className="st16">secondary nonfirm </tspan><tspan x="-1555.27" dy="1.2em" className="st16">power to</tspan></text>		</G>
		<G id="shape1378-376" mid="1378" groupcontext="shape" layermember="0" transform="translate(95,-180)">
			<title></title>
			<desc>1. Environmental regulators are included in federal regulator...</desc>
			
			
			<rect x="0" y="1392.77" width="481" height="155.227" className="st11" style={{fill: 'inherit'}} />
			<text x="4" y="1409.19" className="st12" langid="1033">1. Environmental regulators are included in federal regulators.<tspan
						x="4" dy="1.2em" className="st16">2</tspan>. GENCO performs the NERC functions of GO, GOP or both.<tspan
						x="4" dy="1.2em" className="st16">3</tspan>. TRANSCO performs the NERC functions of TO and TOP.<tspan
						x="4" dy="1.2em" className="st16">4</tspan>. T&#38;D performs NERC functions of TO and DP.<tspan
						x="4" dy="1.2em" className="st16">5</tspan>. G, T &#38; D entity owns generation, transmission and distribution system, but may or may not <tspan
						x="4" dy="1.2em" className="st16">operate generation and transmission systems</tspan>. These do not have their own BA, RP or PA/PC.<tspan
						x="4" dy="1.2em" className="st16">6</tspan>. Vertically Integrated companies are the ones which perform all of the NERC functions- BA, GO, <tspan
						x="4" dy="1.2em" className="st16">GOP</tspan>, PA/PC, RP, TO, TOP, TP, and DP. They may or may not fulfil the function of TSP.<tspan
						x="4" dy="1.2em" className="st16">8</tspan>. C&#38;I customers include agricultural and military loads.<tspan
						x="4" dy="1.2em" className="st16">9</tspan>. In this diagram, only formal relationships have been shown.</text>		</G>
		<G id="shape1379-388" mid="1379" groupcontext="shape" layermember="0" transform="translate(497.34,-1080)" label="BPA Transmission Owner" description="As a Transmission Owner (TO), BPA owns and maintains transmission facilities. It provides maintenance and construction plans and schedules to the Reliability Coordinator (RC) and Transmission Operator (TOP), or revises them on their request. It also provides reactive resources to TOP." >
			<title>BPA Transmission Owner</title>
			<desc>BPA Transmission Owner</desc>
			
				
			
			
			
			<G id="shadow1379-389" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="36.32" y="1510.2" className="st15" langid="1033">BPA <tspan
							x="12.65" dy="1.2em" className="st16">Transmission </tspan><tspan x="30.66" dy="1.2em" className="st16">Owner</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="36.32" y="1510.2" className="st18" langid="1033">BPA <tspan x="12.65"
						dy="1.2em" className="st16">Transmission </tspan><tspan x="30.66" dy="1.2em" className="st16">Owner</tspan></text>		</G>
		<G id="shape1380-400" mid="1380" groupcontext="shape" layermember="0" transform="translate(687.33,-1080)" label="BPA Transmission Operator" description="As a Transmission Operator (TOP), BPA operates the transmission facilities within its purview and ensures real-time operating reliability within its area of service. A TOP monitors the status of and deploys transmission assets (like transmission lines, protection systems) and reactive resources, adjusts flow control devices, and provides telemetry. It also develops system limitations and operates its system within the specified limits. Development and implementation of emergency procedures as well as system restoration plans are also performed by TOP." >
			<title>BPA Transmission Operator</title>
			<desc>BPA Transmission Operator</desc>
			
				
			
			
			
			<G id="shadow1380-401" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="36.32" y="1510.2" className="st15" langid="1033">BPA <tspan
							x="12.65" dy="1.2em" className="st16">Transmission </tspan><tspan x="24.65" dy="1.2em" className="st16">Operator</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="36.32" y="1510.2" className="st18" langid="1033">BPA <tspan x="12.65"
						dy="1.2em" className="st16">Transmission </tspan><tspan x="24.65" dy="1.2em" className="st16">Operator</tspan></text>		</G>
		<G id="shape1381-412" mid="1381" groupcontext="shape" layermember="0" transform="translate(537.66,-990)" label="Bonneville Power Administration" description="The Bonneville Power Administration (BPA) is a nonprofit federal power marketing administration based in the Pacific Northwest. Although BPA is part of the U.S. Department of Energy, it is self-funding and covers its costs by selling its products and services. BPA markets wholesale electrical power from 31 federal hydroelectric projects in the Northwest, one nonfederal nuclear plant and several small nonfederal power plants. BPA provides about 28 percent of the electric power used in the Northwest and its resources (primarily hydroelectric) help make power nearly carbon free. BPA also operates and maintains about three-fourths of the high-voltage transmission in its service territory. BPA's territory includes Idaho, Oregon, Washington, western Montana and small parts of eastern Montana, California, Nevada, Utah and Wyoming." >
			<title>Bonneville Power Administration</title>
			<desc>Bonneville Power Administration</desc>
			
			
			<rect x="0" y="1521" width="211.5" height="27" className="st11" style={{fill: 'inherit'}} />
			<text x="9.44" y="1538.7" className="st39" langid="1033">Bonneville Power Administration</text>		</G>
		<G id="shape1383-415" mid="1383" groupcontext="shape" layermember="0" transform="translate(875.34,-1116)" label="Gen" description="Entity class includes organizations which serve the functions of Generator Owner and/or Generator Operators, and provide power (both real and reactive power) and reliability-related services. They monitor the status of the generating units and related equipment and report their operating and availability status to Balancing Authority (BA) and Transmission Operator (TOP). " >
			<title>Generator Owner and/or Operator</title>
			<desc>Gen</desc>
			
				
			
			
			
			<G id="shadow1383-416" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="36.99" y="1524.6" className="st15" langid="1033">Gen</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="36.99" y="1524.6" className="st18" langid="1033">Gen</text>		</G>
		<G id="shape1387-423" mid="1387" groupcontext="shape" layermember="0" transform="translate(1026,-741.375)" label="G, T &#38; D" description="Generation, Transmission & Distribution (G, T & D) is the entity class that consist of utilities that own and maintain generation as well as transmission facilities, and operate their own distribution system to deliver power to the customers. Few of these utilities under this entity class also perform the functions of generation operator or/and transmission operator." >
			<title>Generation, Transmission & Distribution</title>
			<desc>G, T &#38; D</desc>
			
				
			
			
			
			<G id="shadow1387-424" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1374.75" width="96.66" height="173.25" className="st13" style={{fill: 'inherit'}} />
				<text x="28.27" y="1465.07" className="st40" langid="1033">G, T &#38; D</text>			</G>
			<rect x="0" y="1374.75" width="96.66" height="173.25" className="st17" style={{fill: 'inherit'}} />
			<text x="28.27" y="1465.07" className="st12" langid="1033">G, T &#38; D</text>		</G>
		<G id="shape1388-431" mid="1388" groupcontext="shape" layermember="1" transform="translate(104.22,-1026)">
			<title></title>
			<desc>created &#62;</desc>
			
			
			<path d="M9 1548 L9 1503 L9 1458" className="st19"/>
			<rect rectcontext="textBkgnd" x="-1536.43" y="-9.04481" width="45.9613" height="14.4001" transform="rotate(-90)"
					className="st41" style={{fill: 'inherit'}} />
			<text x="-1536.43" y="1.76" transform="rotate(-90)" className="st21" langid="1033">created &#62;</text>		</G>
		<G id="shape1393-440" mid="1393" groupcontext="shape" layermember="0" transform="translate(1043.42,-855)">
			<title></title>
			<desc>Gen.</desc>
			
				
			
			
			
			<G id="shadow1393-441" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="17.91" y="1534.33" className="st15" langid="1033">Gen.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="17.91" y="1534.33" className="st18" langid="1033">Gen.</text>		</G>
		<G id="shape1394-448" mid="1394" groupcontext="shape" layermember="0" transform="translate(1043.42,-784.458)">
			<title></title>
			<desc>Trans.</desc>
			
				
			
			
			
			<G id="shadow1394-449" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="13.91" y="1534.33" className="st15" langid="1033">Trans.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="13.91" y="1534.33" className="st18" langid="1033">Trans.</text>		</G>
		<G id="shape1395-456" mid="1395" groupcontext="shape" layermember="0" transform="translate(1043.42,-747)">
			<title></title>
			<desc>Dist.</desc>
			
				
			
			
			
			<G id="shadow1395-457" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="18.91" y="1534.33" className="st15" langid="1033">Dist.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="18.91" y="1534.33" className="st18" langid="1033">Dist.</text>		</G>
		<G id="shape1397-464" mid="1397" groupcontext="shape" layermember="0" transform="translate(1175.67,-840.857)" label="Fully Vertically Integrated" description="The traditional definition of a &quot;vertically integrated&quot; utility is one that owns all levels of the supply chain: generation, transmission and distribution. Each entity in this class also serves the function of Balancing Authority (BA) in its territory." >
			<title>Fully Vertically Integrated</title>
			<desc>Fully Vertically Integrated</desc>
			
				
			
			
			
			<G id="shadow1397-465" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1308.86" width="96.66" height="239.143" className="st13" style={{fill: 'inherit'}} />
				<text x="12.85" y="1424.64" className="st40" langid="1033">Fully Vertically <tspan
							x="22.73" dy="1.223em" className="st16">Integrated</tspan></text>			</G>
			<rect x="0" y="1308.86" width="96.66" height="239.143" className="st17" style={{fill: 'inherit'}} />
			<text x="12.85" y="1424.64" className="st12" langid="1033">Fully Vertically <tspan
						x="22.73" dy="1.223em" className="st16">Integrated</tspan></text>		</G>
		<G id="shape1398-474" mid="1398" groupcontext="shape" layermember="0" transform="translate(1193.09,-1031.96)">
			<title></title>
			<desc>Gen.</desc>
			
				
			
			
			
			<G id="shadow1398-475" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="17.91" y="1534.33" className="st15" langid="1033">Gen.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="17.91" y="1534.33" className="st18" langid="1033">Gen.</text>		</G>
		<G id="shape1399-482" mid="1399" groupcontext="shape" layermember="0" transform="translate(1193.09,-983.25)">
			<title></title>
			<desc>Trans.</desc>
			
				
			
			
			
			<G id="shadow1399-483" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="13.91" y="1534.33" className="st15" langid="1033">Trans.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="13.91" y="1534.33" className="st18" langid="1033">Trans.</text>		</G>
		<G id="shape1400-490" mid="1400" groupcontext="shape" layermember="0" transform="translate(1193.09,-900)">
			<title></title>
			<desc>Dist.</desc>
			
				
			
			
			
			<G id="shadow1400-491" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="18.91" y="1534.33" className="st15" langid="1033">Dist.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="18.91" y="1534.33" className="st18" langid="1033">Dist.</text>		</G>
		<G id="shape1402-498" mid="1402" groupcontext="shape" layermember="0" transform="translate(1193.09,-855)">
			<title></title>
			<desc>BA</desc>
			
				
			
			
			
			<G id="shadow1402-499" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="22.91" y="1534.33" className="st15" langid="1033">BA</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="22.91" y="1534.33" className="st18" langid="1033">BA</text>		</G>
		<G id="shape1403-506" mid="1403" groupcontext="shape" layermember="0" transform="translate(872.505,-747)" label="T &#38; D" description="Transmission & Distribution (T & D) is the entity class that consist of utilities that serve as both Transmission Owners (i.e. own and maintain their own transmission facilities), and Distribution Providers (i.e. operate their own distribution system) to deliver power to the customers." >
			<title>Transmission & Distribution</title>
			<desc>T &#38; D</desc>
			
				
			
			
			
			<G id="shadow1403-507" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1413" width="96.66" height="135" className="st13" style={{fill: 'inherit'}} />
				<text x="34.91" y="1484.19" className="st40" langid="1033">T &#38; D</text>			</G>
			<rect x="0" y="1413" width="96.66" height="135" className="st17" style={{fill: 'inherit'}} />
			<text x="34.91" y="1484.19" className="st12" langid="1033">T &#38; D</text>		</G>
		<G id="shape1405-514" mid="1405" groupcontext="shape" layermember="0" transform="translate(889.92,-829.458)">
			<title></title>
			<desc>Trans.</desc>
			
				
			
			
			
			<G id="shadow1405-515" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="13.91" y="1534.33" className="st15" langid="1033">Trans.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="13.91" y="1534.33" className="st18" langid="1033">Trans.</text>		</G>
		<G id="shape1406-522" mid="1406" groupcontext="shape" layermember="0" transform="translate(890.58,-761.958)">
			<title></title>
			<desc>Dist.</desc>
			
				
			
			
			
			<G id="shadow1406-523" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="18.91" y="1534.33" className="st15" langid="1033">Dist.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="18.91" y="1534.33" className="st18" langid="1033">Dist.</text>		</G>
		<G id="shape1408-530" mid="1408" groupcontext="shape" layermember="0" transform="translate(1022.67,-1041.75)" label="G &#38; T" description="Generation & Transmission (G & T) are utilities, typically cooperatives, that generate and transmit wholesale power to distribution co-ops." >
			<title>Generation & Transmission</title>
			<desc>G &#38; T</desc>
			
				
			
			
			
			<G id="shadow1408-531" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1413" width="96.66" height="135" className="st13" style={{fill: 'inherit'}} />
				<text x="34.82" y="1484.19" className="st40" langid="1033">G &#38; T</text>			</G>
			<rect x="0" y="1413" width="96.66" height="135" className="st17" style={{fill: 'inherit'}} />
			<text x="34.82" y="1484.19" className="st12" langid="1033">G &#38; T</text>		</G>
		<G id="shape1409-538" mid="1409" groupcontext="shape" layermember="0" transform="translate(1040.09,-1129.5)">
			<title></title>
			<desc>Gen.</desc>
			
				
			
			
			
			<G id="shadow1409-539" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="17.91" y="1534.33" className="st15" langid="1033">Gen.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="17.91" y="1534.33" className="st18" langid="1033">Gen.</text>		</G>
		<G id="shape1410-546" mid="1410" groupcontext="shape" layermember="0" transform="translate(1040.09,-1054.46)">
			<title></title>
			<desc>Trans.</desc>
			
				
			
			
			
			<G id="shadow1410-547" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st42"/>
				<text x="13.91" y="1534.33" className="st15" langid="1033">Trans.</text>			</G>
			<path d="M0 1548 L61.83 1548 L61.83 1513.46 L0 1513.46 L0 1548 Z" className="st43"/>
			<text x="13.91" y="1534.33" className="st18" langid="1033">Trans.</text>		</G>
		<G id="shape1412-554" mid="1412" groupcontext="shape" layermember="0" transform="translate(936,-648)" label="Power Marketers" description="Power Marketers usually own or control generation or transmission facilities but act as intermediaries by purchasing electricity from numerous utilities and reselling it to other utilities or distribution providers. By taking advantage of the disparities in prices and determining their best combination, they can provide better prices to their customers while making a profit for themselves. Registration with the FERC is necessary to obtain status as a power marketer. " >
			<title>Power Marketers</title>
			<desc>Power Marketers</desc>
			
				
			
			
			
			<G id="shadow1412-555" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="31.32" y="1517.4" className="st15" langid="1033">Power <tspan
							x="21.66" dy="1.2em" className="st16">Marketers</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="31.32" y="1517.4" className="st18" langid="1033">Power <tspan
						x="21.66" dy="1.2em" className="st16">Marketers</tspan></text>		</G>
		<G id="shape1413-564" mid="1413" groupcontext="shape" layermember="0" transform="translate(936,-477)" label="Exchanges" description="Exchanges are the energy market places for trading electricity as a commodity. They allow longer term hedging than the Day-Ahead Market (DAM) and Real-Time Markets (RTM) which allow hedging of only up to maximum of 24 hours in advance of the operating period. In order to protect against price volatility of wholesale electricity, market participants take resort to longer-dated hedges in other markets such as Nodal Exchange, Intercontinental Exchange (ICE) or New York Mercantile Exchange (NYMEX). The two parties, i.e. the buyer and the seller, can also arrange a bilateral agreement. Futures contracts are traded on the NYMEX which allows generators, power marketers and end-users to hedge against unexpected price fluctuations. Over-the-Counter (OTC) energy market operated by Intercontinental ICE also provides bilateral contracts for utilities to settle at a guaranteed price for electricity, and therefore minimize financial risks associated with electrical energy production. The exchanges publish spot market prices for various supply or delivery points in the electric power system. For example, there is a Mid-C price index for the power sold by the dams on the Columbia River owned by some of the PUDs in the State of Washington. Power exchanges are points of arbitrage and present an opportunity for resources capable of load shifting, such as battery storage systems, to earn revenue by buying power when prices are low and reselling when they are high." >
			<title>Exchanges</title>
			<desc>Exchanges</desc>
			
				
			
			
			
			<G id="shadow1413-565" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="18.64" y="1524.6" className="st15" langid="1033">Exchanges</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="18.64" y="1524.6" className="st18" langid="1033">Exchanges</text>		</G>
		<G id="shape1414-572" mid="1414" groupcontext="shape" layermember="5" transform="translate(949.097,-586.617)">
			<title></title>
			<desc>&#60; power trading</desc>
			
			
			<rect x="0" y="1518.12" width="70.83" height="29.8826" className="st11" style={{fill: 'inherit'}} />
			<text x="-1553.09" y="31.82" transform="rotate(-90)" className="st34" langid="1033">&#60; power <tspan
						x="-1550.54" dy="1.2em" className="st16">trading</tspan></text>		</G>
		<G id="shape1415-576" mid="1415" groupcontext="shape" layermember="5" transform="translate(975.33,-531)">
			<title></title>
			<path d="M9 1548 L9 1443.06" className="st38"/>
		</G>
		<G id="shape1416-583" mid="1416" groupcontext="shape" layermember="1" transform="translate(277.11,-1026)">
			<title></title>
			<desc>regulates federal dams and generators &#62;</desc>
			
			
			<path d="M0 1548 L-0 1296 L646.56 1296 L646.56 1404" className="st44"/>
			<rect rectcontext="textBkgnd" x="155.689" y="1279.8" width="197.169" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="155.69" y="1290.6" className="st21" langid="1033">regulates federal dams and generators &#62;</text>		</G>
		<G id="shape1417-593" mid="1417" groupcontext="shape" layermember="1" transform="translate(325.44,-1033.88)">
			<title></title>
			<desc>oversight on compliance &#62;</desc>
			
			
			<path d="M0 1555.87 L-0 1334.29 L391.11 1334.29 A3 3 0 0 1 397.11 1334.29 L520.56 1334.29 L520.56 1558.12 L522.96 1558.12
						 A3 3 0 0 1 528.96 1558.12 L540.9 1558.12" className="st44"/>
			<rect rectcontext="textBkgnd" x="208.68" y="1315.01" width="127.97" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="208.68" y="1325.81" className="st21" langid="1033">oversight on compliance &#62;</text>		</G>
		<G id="shape1418-602" mid="1418" groupcontext="shape" layermember="2" transform="translate(363.33,-904.5)">
			<title></title>
			<desc>regulates IoU &#62;</desc>
			
			
			<path d="M0 1548 L21.54 1548 A3 3 0 0 1 27.54 1548 L38.67 1548 A3 3 0 0 1 44.67 1548 L69.45 1548 A3 3 0 0 1 75.45 1548
						 L169.92 1548 A3 3 0 0 1 175.92 1548 L179.34 1548 A3 3 0 0 1 185.34 1548 L211.56 1548 A3 3 0 0 1 217.56 1548
						 L245.67 1548 A3 3 0 1 1 251.67 1548 L262.54 1548 A3 3 0 1 1 268.54 1548 L380.67 1548 A3 3 0 1 1 386.67 1548
						 L470.67 1548 A3 3 0 1 1 476.67 1548 L485.07 1548 A3 3 0 0 1 491.07 1548 L587.19 1548 A3 3 0 1 1 593.19 1548
						 L600.86 1548 A3 3 0 1 1 606.86 1548 L636.19 1548 A3 3 0 1 1 642.19 1548 L653.67 1548 L653.67 1512 L708 1512
						 A3 3 0 0 1 714 1512 L724.11 1512 A3 3 0 1 1 730.11 1512 L773.07 1512 A3 3 0 1 1 779.07 1512 L791.34 1512
						 A3 3 0 0 1 797.34 1512 L812.34 1512" className="st45"/>
			<rect rectcontext="textBkgnd" x="292.797" y="1531.8" width="73.7463" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="292.8" y="1542.6" className="st24" langid="1033">regulates IoU &#62;</text>		</G>
		<G id="shape1419-612" mid="1419" groupcontext="shape" layermember="6" transform="translate(715.965,-899.185)">
			<title></title>
			<path d="M0 1555.56 L28.03 1555.82 A3 3 0 0 1 34.03 1555.88 L118.03 1556.66 A3 3 0 0 1 124.03 1556.71 L132.43 1556.79
						 A3 3 0 0 1 138.43 1556.85 L234.24 1557.73 A3 3 0 1 1 240.24 1557.79 L248.22 1557.86 A3 3 0 0 1 254.22 1557.92
						 L310.03 1558.44" className="st28"/>
		</G>
		<G id="shape1420-617" mid="1420" groupcontext="shape" layermember="6" transform="translate(1002.52,-888.967)">
			<title></title>
			<path d="M0 1548 L0 1293.97 L20.15 1293.97" className="st28"/>
		</G>
		<G id="shape1421-622" mid="1421" groupcontext="shape" layermember="6" transform="translate(1004.08,-1134)">
			<title></title>
			<path d="M0 1539 L-4.82 1539 A3 3 -180 0 0 -10.82 1539 L-32.08 1539" className="st28"/>
		</G>
		<G id="shape1422-627" mid="1422" groupcontext="shape" layermember="6" transform="translate(1004.19,-1009.61)">
			<title></title>
			<path d="M0 1540.61 L63.81 1539.41 A3 3 0 1 1 69.81 1539.3 L83.25 1539.05 A3 3 0 1 1 89.25 1538.93 L132.21 1538.13 A3
						 3 0 0 1 138.21 1538.02 L150.48 1537.79 A3 3 0 0 1 156.48 1537.67 L171.48 1537.39" className="st28"/>
		</G>
		<G id="shape1423-632" mid="1423" groupcontext="shape" layermember="6" transform="translate(1002.52,-888.967)">
			<title></title>
			<path d="M0 1548 L0 1588.72 L-33.36 1588.72" className="st28"/>
		</G>
		<G id="shape1424-637" mid="1424" groupcontext="shape" layermember="5" transform="translate(694.08,-1228.75)">
			<title></title>
			<path d="M0 1548 L22.47 1548 A3 3 0 1 1 28.47 1548 L148.92 1548 A3 3 0 1 1 154.92 1548 L163.32 1548 L163.32 1647.25 L169.2
						 1647.25" className="st38"/>
		</G>
		<G id="shape1425-644" mid="1425" groupcontext="shape" layermember="5" transform="translate(857.4,-1161.33)">
			<title></title>
			<path d="M0 1548 L0 1633.83 L113.07 1633.83 A3 3 0 0 1 119.07 1633.83 L129.37 1633.83 A3 3 0 1 1 135.37 1633.83 L135.86
						 1633.83 A3 3 0 0 1 141.86 1633.83 L142.12 1633.83 A3 3 0 1 1 148.12 1633.83 L153.21 1633.83" className="st46"/>
		</G>
		<G id="shape1426-649" mid="1426" groupcontext="shape" layermember="5" transform="translate(951.334,-1075.5)">
			<title></title>
			<path d="M0 1548 L19.13 1548 A3 3 0 1 1 25.13 1548 L35.44 1548 A3 3 0 0 1 41.44 1548 L41.93 1548 A3 3 0 1 1 47.93 1548
						 L48.19 1548 A3 3 0 1 1 54.19 1548 L56.67 1548 L56.67 1598.1 L116.67 1598.1 A3 3 0 1 1 122.67 1598.1 L139.11
						 1598.1 L139.11 1696.82" className="st46"/>
		</G>
		<G id="shape1427-654" mid="1427" groupcontext="shape" layermember="5" transform="translate(1090.44,-1001.54)">
			<title></title>
			<path d="M0 1554.46 L0 1559.54 L45.96 1559.54 A3 3 0 0 1 51.96 1559.54 L64.23 1559.54 A3 3 0 0 1 70.23 1559.54 L73.17
						 1559.54" className="st46"/>
		</G>
		<G id="shape1428-659" mid="1428" groupcontext="shape" layermember="5" transform="translate(711,-1215.25)">
			<title></title>
			<desc>markets power from hydro generators to &#62;</desc>
			
			
			<rect x="0" y="1521" width="126" height="27" className="st11" style={{fill: 'inherit'}} />
			<text x="12.9" y="1530.9" className="st34" langid="1033">markets power from <tspan
						x="9.97" dy="1.2em" className="st16">hydro generators to </tspan>&#62;</text>		</G>
		<G id="shape1430-663" mid="1430" groupcontext="shape" layermember="3" transform="translate(594,-949.5)">
			<title></title>
			<path d="M0 1548 L15 1548 A3 3 0 0 1 21 1548 L27 1548 L27 1569.5 L240 1569.5 A3 3 0 0 1 246 1569.5 L254.4 1569.5 A3 3
						 0 0 1 260.4 1569.5 L392.77 1569.5 A3 3 0 0 1 398.77 1569.5 L405.52 1569.5 A3 3 0 0 1 411.52 1569.5 L420
						 1569.5 A3 3 0 0 1 426 1569.5 L448.11 1569.5 L448.11 1582.87" className="st29"/>
		</G>
		<G id="shape1431-670" mid="1431" groupcontext="shape" layermember="3" transform="translate(982.466,-928)">
			<title></title>
			<path d="M0 1548 L-9 1548 L-9 1375.55 L-26.58 1375.55 L-26.58 1360" className="st47"/>
		</G>
		<G id="shape1432-675" mid="1432" groupcontext="shape" layermember="3" transform="translate(973.466,-1094.11)">
			<title></title>
			<path d="M0 1545.14 L-0 1532.86 L19.8 1532.86 A3 3 0 0 1 25.8 1532.86 L26.06 1532.86 A3 3 0 0 1 32.06 1532.86 L49.2 1532.86"
					className="st47"/>
		</G>
		<G id="shape1434-680" mid="1434" groupcontext="shape" layermember="3" transform="translate(962.528,-928)">
			<title></title>
			<path d="M-8.53 1548 L-9.47 1594" className="st47"/>
		</G>
		<G id="shape1435-685" mid="1435" groupcontext="shape" layermember="3" transform="translate(762.904,-928)">
			<title></title>
			<path d="M-2.1 1548 L-2.1 1561.5 L-15.9 1561.5 L-15.9 1612" className="st47"/>
		</G>
		<G id="shape1436-690" mid="1436" groupcontext="shape" layermember="3" transform="translate(545.67,-936)">
			<title></title>
			<desc>&#60; dispatch DER/DR</desc>
			
			
			<path d="M0 1548 L-0 1795.5 L-17.28 1795.5" className="st48"/>
			<rect rectcontext="textBkgnd" x="-1706.31" y="-18.0898" width="90.897" height="14.4001" transform="rotate(-90)"
					className="st41" style={{fill: 'inherit'}} />
			<text x="-1706.31" y="-7.29" transform="rotate(-90)" className="st31" langid="1033">&#60; dispatch DER/DR</text>		</G>
		<G id="shape1437-700" mid="1437" groupcontext="shape" layermember="4" transform="translate(767.88,-1080)">
			<title></title>
			<path d="M0 1548 L0 1575 L66.12 1575 A3 3 0 0 1 72.12 1575 L75.12 1575 A5.7 5.7 0 1 1 86.52 1575 L179.01 1575 L179.01
						 1578.69" className="st35"/>
		</G>
		<G id="shape1439-707" mid="1439" groupcontext="shape" layermember="4" transform="translate(747,-1042)">
			<title></title>
			<desc>deploys TO resources &#62;</desc>
			
			
			<rect x="0" y="1528" width="96.66" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="21.18" y="1534.4" className="st37" langid="1033">deploys TO <tspan
						x="20.28" dy="1.2em" className="st16">resources </tspan>&#62;</text>		</G>
		<G id="shape1440-711" mid="1440" groupcontext="shape" layermember="4" transform="translate(594,-1098)">
			<title></title>
			<desc>deploys resources &#62;</desc>
			
			
			<path d="M0 1539 L93.33 1539" className="st49"/>
			<rect rectcontext="textBkgnd" x="16.9541" y="1506.6" width="56.0921" height="28.8001" className="st41" style={{fill: 'inherit'}} />
			<text x="26.11" y="1517.4" className="st37" langid="1033">deploys <tspan
						x="16.95" dy="1.2em" className="st16">resources </tspan>&#62;</text>		</G>
		<G id="shape1441-722" mid="1441" groupcontext="shape" layermember="4" transform="translate(719.55,-1134)">
			<title></title>
			<desc>&#60; TOPs interchange power &#62;</desc>
			
			
			<path d="M0 1548 L0 1422 L201.12 1422 A3 3 0 1 1 207.12 1422 L472.23 1422 L472.23 1589.94" className="st35"/>
			<rect rectcontext="textBkgnd" x="255.88" y="1403.55" width="137.139" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="255.88" y="1414.35" className="st37" langid="1033">&#60; TOPs interchange power &#62;</text>		</G>
		<G id="shape1442-731" mid="1442" groupcontext="shape" layermember="4" transform="translate(1191.78,-1098)">
			<title></title>
			<path d="M0 1548 L-34.11 1548 L-34.11 1774.69 L-57.06 1774.69" className="st50"/>
		</G>
		<G id="shape1443-736" mid="1443" groupcontext="shape" layermember="4" transform="translate(734.715,-1080)">
			<title></title>
			<path d="M0.94 1548 L0.94 1608.75 L17.06 1608.75 L17.06 1638" className="st49"/>
		</G>
		<G id="shape1444-743" mid="1444" groupcontext="shape" layermember="4" transform="translate(695.835,-1034)">
			<title></title>
			<desc>coordinates transfer capability 1&#62;</desc>
			
			
			<rect x="0" y="1528" width="84.33" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="-1566.85" y="31.37" transform="rotate(-90)" className="st37" langid="1033">coordinates <tspan
						x="-1557.38" dy="1.2em" className="st16">transfer </tspan><tspan x="-1568.83" dy="1.2em" className="st16">capability </tspan>1&#62;</text>		</G>
		<G id="shape1445-748" mid="1445" groupcontext="shape" layermember="6" transform="translate(168.66,-598.5)">
			<title></title>
			<desc>enforces compliance &#62;</desc>
			
			
			<path d="M0 1548 L101.34 1548 L101.34 1410.14 L169.89 1410.14 A3 3 0 0 1 175.89 1410.14 L216.21 1410.14 A3 3 0 0 1 222.21
						 1410.14 L264.12 1410.14 A3 3 0 0 1 270.12 1410.14 L328.56 1410.14 A3 3 0 0 1 334.56 1410.14 L374.01 1410.14
						 A3 3 0 0 1 380.01 1410.14 L406.23 1410.14 A3 3 0 0 1 412.23 1410.14 L460.21 1410.14 L460.21 1225.12"
					className="st51"/>
			<rect rectcontext="textBkgnd" x="-1538.81" y="85.1402" width="109.489" height="14.4001" transform="rotate(-90)"
					className="st41" style={{fill: 'inherit'}} />
			<text x="-1538.81" y="95.94" transform="rotate(-90)" className="st53" langid="1033">enforces compliance &#62;</text>		</G>
		<G id="shape1446-759" mid="1446" groupcontext="shape" layermember="6" transform="translate(270,-731.786)">
			<title></title>
			<path d="M0 1548 L71.55 1548 L71.55 1523.79" className="st54"/>
		</G>
		<G id="shape1447-764" mid="1447" groupcontext="shape" layermember="6" transform="translate(608.112,-736.364)">
			<title></title>
			<path d="M0 1548 L0 1555.36 L42.56 1555.36 A3 3 0 0 1 48.56 1555.36 L99.89 1555.36 A3 3 0 0 1 105.89 1555.36 L135.89
						 1555.36 A3 3 0 0 1 141.89 1555.36 L225.89 1555.36 A3 3 0 1 1 231.89 1555.36 L277.5 1555.36 A3 3 0 1 1 283.5
						 1555.36 L293.61 1555.36 A3 3 0 0 1 299.61 1555.36 L341.94 1555.36 A3 3 0 0 1 347.94 1555.36 L447.11 1555.36
						 A3 3 0 0 1 453.11 1555.36 L463.22 1555.36 A3 3 0 0 1 469.22 1555.36 L495.44 1555.36 A3 3 0 0 1 501.44 1555.36
						 L580.67 1555.36 A3 3 0 0 1 586.67 1555.36 L612.89 1555.36 A3 3 0 0 1 618.89 1555.36 L645.11 1555.36 A3 3
						 0 0 1 651.11 1555.36 L674.72 1555.36 A3 3 0 0 1 680.72 1555.36 L691.26 1555.36 L691.26 1264.15 L680.76 1264.15
						 A3 3 -180 0 0 674.76 1264.15 L664.22 1264.15" className="st55"/>
		</G>
		<G id="shape1448-770" mid="1448" groupcontext="shape" layermember="6" transform="translate(973.275,-729)">
			<title></title>
			<path d="M0 1548 L18.53 1548 L18.53 1449 L52.73 1449" className="st55"/>
		</G>
		<G id="shape1449-775" mid="1449" groupcontext="shape" layermember="6" transform="translate(991.8,-802.851)">
			<title></title>
			<path d="M0 1541.65 L0 1536.35 L-22.64 1536.35" className="st55"/>
		</G>
		<G id="shape1450-780" mid="1450" groupcontext="shape" layermember="6" transform="translate(1299.38,-1016.02)">
			<title></title>
			<path d="M0 1548 L-13.5 1548 L-13.5 1380.52 L-104.59 1380.52 A3 3 -180 1 0 -110.59 1380.52 L-156.97 1380.52 A3 3 -180
						 1 0 -162.97 1380.52 L-241.49 1380.52 A3 3 -180 0 0 -247.49 1380.52 L-343.49 1380.52 L-343.49 1394.02"
					className="st55"/>
		</G>
		<G id="shape1451-785" mid="1451" groupcontext="shape" layermember="6" transform="translate(1140.51,-1183.5)">
			<title></title>
			<path d="M0 1548 L0 1622.25 L-21.18 1622.25" className="st56"/>
		</G>
		<G id="shape1452-791" mid="1452" groupcontext="shape" layermember="6" transform="translate(996.262,-1183.5)">
			<title></title>
			<path d="M0 1548 L0 1707.75 L-3.49 1707.75 A3 3 -180 0 0 -9.49 1707.75 L-19.8 1707.75 A3 3 -180 0 0 -25.8 1707.75 L-33.26
						 1707.75" className="st55"/>
		</G>
		<G id="shape1454-796" mid="1454" groupcontext="shape" layermember="6" transform="translate(720,-729)">
			<title></title>
			<path d="M9 1548 L9 1467" className="st56"/>
		</G>
		<G id="shape1455-801" mid="1455" groupcontext="shape" layermember="4" transform="translate(735.66,-1134)">
			<title></title>
			<path d="M0 1548 L0 1525.5 L98.34 1525.5 A3 3 0 1 1 104.34 1525.5 L107.34 1525.5 A3 3 0 0 1 113.34 1525.5 L118.74 1525.5
						 A3 3 0 1 1 124.74 1525.5 L127.62 1525.5" className="st35"/>
		</G>
		<G id="shape1457-808" mid="1457" groupcontext="shape" layermember="4" transform="translate(850.812,-1156.5)">
			<title></title>
			<path d="M0 1548 L-0 1505.25 L3.59 1505.25 A3 3 0 0 1 9.59 1505.25 L69.86 1505.25 A3 3 0 0 1 75.86 1505.25 L204.08 1505.25
						 L204.08 1515.69" className="st50"/>
		</G>
		<G id="shape1458-813" mid="1458" groupcontext="shape" layermember="4" transform="translate(702,-1152)">
			<title></title>
			<desc>&#60; provides bulk power</desc>
			
			
			<rect x="0" y="1528" width="152" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="21.87" y="1541.6" className="st37" langid="1033">&#60; provides bulk power  </text>		</G>
		<G id="shape1459-816" mid="1459" groupcontext="shape" layermember="4" transform="translate(792.495,-1120.5)">
			<title></title>
			<path d="M-8.51 1548 L41.5 1548 A3 3 0 1 1 47.5 1548 L50.5 1548 A3 3 0 1 1 56.5 1548 L58.9 1548 L58.9 1845 L47.5 1845
						 A3 3 -180 0 0 41.5 1845 L2.57 1845" className="st35"/>
		</G>
		<G id="shape1460-823" mid="1460" groupcontext="shape" layermember="4" transform="translate(778.17,-810)">
			<title></title>
			<desc>&#60; transmits bulk power to</desc>
			
			
			<rect x="0" y="1503" width="70.83" height="45" className="st11" style={{fill: 'inherit'}} />
			<text x="8.07" y="1514.7" className="st37" langid="1033">&#60; transmits <tspan
						x="7.97" dy="1.2em" className="st16">bulk power </tspan><tspan x="30.24" dy="1.2em" className="st16">to</tspan></text>		</G>
		<G id="shape1462-828" mid="1462" groupcontext="shape" layermember="4" transform="translate(891.076,-1053)">
			<title></title>
			<path d="M0 1548 L79.39 1548 A3 3 0 1 1 85.39 1548 L98.7 1548 L98.7 1507.5 L102.19 1507.5 A3 3 0 0 1 108.19 1507.5 L108.45
						 1507.5 A3 3 0 0 1 114.45 1507.5 L119.53 1507.5" className="st50"/>
		</G>
		<G id="shape1463-833" mid="1463" groupcontext="shape" layermember="5" transform="translate(1256.22,-840.857)">
			<title></title>
			<desc>&#60; buy/sell EIM incremental power &#62;</desc>
			
			
			<path d="M0 1559.7 L0 1560.06 L0 1740.86 L-25.56 1740.86" className="st58"/>
			<rect rectcontext="textBkgnd" x="-1723.28" y="-18.0898" width="173.544" height="14.4001" transform="rotate(-90)"
					className="st41" style={{fill: 'inherit'}} />
			<text x="-1723.28" y="-7.29" transform="rotate(-90)" className="st34" langid="1033">&#60; buy/sell EIM incremental power &#62;</text>		</G>
		<G id="shape1464-843" mid="1464" groupcontext="shape" layermember="5" transform="translate(747,-810)">
			<title></title>
			<path d="M-0 1559.7 L-0 1560.06 L-0 1647 L87 1647 A3 3 0 0 1 93 1647 L138.62 1647 A3 3 0 0 1 144.62 1647 L154.72 1647
						 A3 3 0 0 1 160.72 1647 L311.22 1647 L311.22 1628.68" className="st59"/>
		</G>
		<G id="shape1465-850" mid="1465" groupcontext="shape" layermember="5" transform="translate(902.285,-711)">
			<title></title>
			<path d="M0 1548 L50.77 1548 L50.77 1524.06" className="st46"/>
		</G>
		<G id="shape1466-855" mid="1466" groupcontext="shape" layermember="5" transform="translate(860.246,-711)">
			<title></title>
			<path d="M0 1548 L0 1597.5 L25.37 1597.5 A3 3 0 0 1 31.37 1597.5 L41.48 1597.5 A3 3 0 0 1 47.48 1597.5 L63.69 1597.5"
					className="st46"/>
		</G>
		<G id="shape1467-860" mid="1467" groupcontext="shape" layermember="5" transform="translate(828,-675.104)">
			<title></title>
			<desc>&#60; power trading</desc>
			
			
			<rect x="0" y="1521.1" width="63.75" height="26.8956" className="st11" style={{fill: 'inherit'}} />
			<text x="-1554.58" y="28.28" transform="rotate(-90)" className="st34" langid="1033">&#60; power <tspan
						x="-1552.03" dy="1.2em" className="st16">trading</tspan></text>		</G>
		<G id="shape1471-864" mid="1471" groupcontext="shape" layermember="8" transform="translate(772.56,-720)">
			<title></title>
		</G>
		<G id="shape1472-865" mid="1472" groupcontext="shape" layermember="8" transform="translate(772.56,-720)">
			<title></title>
		</G>
		<G id="shape1473-866" mid="1473" groupcontext="shape" layermember="3" transform="translate(711,-810)">
			<title></title>
			<path d="M0 1548 L-0 1657 L-54.33 1657 A3 3 -180 0 0 -60.33 1657 L-109.89 1657 L-109.89 1805.94" className="st48"/>
		</G>
		<G id="shape1474-873" mid="1474" groupcontext="shape" layermember="3" transform="translate(705.575,-701)">
			<title></title>
			<path d="M0 1548 L116.75 1548 L116.75 1709" className="st47"/>
		</G>
		<G id="shape1475-878" mid="1475" groupcontext="shape" layermember="3" transform="translate(680.085,-764.55)">
			<title></title>
			<desc>&#60; dispatch DER/DR</desc>
			
			
			<rect x="0" y="1536.55" width="61.83" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="-1567.22" y="27.32" transform="rotate(-90)" className="st31" langid="1033">&#60; dispatch <tspan
						x="-1561.42" dy="1.2em" className="st16">DER</tspan>/DR</text>		</G>
		<G id="shape1477-882" mid="1477" groupcontext="shape" layermember="7" transform="translate(675,-850.5)">
			<title></title>
			<path d="M0 1548 L-21.33 1548 L-21.33 1872 L-29.61 1872" className="st60"/>
		</G>
		<G id="shape1479-891" mid="1479" groupcontext="shape" layermember="7" transform="translate(653.67,-517.5)">
			<title></title>
			<path d="M0 1539 L120.33 1539" className="st62"/>
		</G>
		<G id="shape1480-897" mid="1480" groupcontext="shape" layermember="7" transform="translate(587.25,-783.104)">
			<title></title>
			<desc>&#60; buy/sell and distribute retail electricity</desc>
			
			
			<rect x="0" y="1521.1" width="132.75" height="26.8956" className="st11" style={{fill: 'inherit'}} />
			<text x="-1593.87" y="62.78" transform="rotate(-90)" className="st63" langid="1033">&#60; buy/sell and distribute <tspan
						x="-1572.63" dy="1.2em" className="st16">retail electricity</tspan></text>		</G>
		<G id="shape1491-901" mid="1491" groupcontext="shape" layermember="3" transform="translate(1106.55,-741.375)">
			<title></title>
			<path d="M0 1548 L0 1866.37 L-29.22 1866.37 A3 3 -180 0 0 -35.22 1866.37 L-198.83 1866.37 A3 3 -180 0 0 -204.83 1866.37
						 L-214.93 1866.37 A3 3 -180 0 0 -220.93 1866.37 L-268.11 1866.37 L-268.11 1803.37" className="st29"/>
		</G>
		<G id="shape1492-908" mid="1492" groupcontext="shape" layermember="3" transform="translate(838.44,-425.305)">
			<title></title>
			<path d="M0 1548 L-13.11 1548 A3 3 -180 0 0 -19.11 1548 L-29.22 1548 A3 3 -180 1 0 -35.22 1548 L-45.33 1548 A3 3 -180
						 1 0 -51.33 1548 L-218.22 1548 A3 3 -180 1 0 -224.22 1548 L-234.33 1548 A3 3 -180 1 0 -240.33 1548 L-269.55
						 1548 L-269.55 1499.36" className="st64"/>
		</G>
		<G id="shape1493-913" mid="1493" groupcontext="shape" layermember="3" transform="translate(1053,-594)">
			<title></title>
			<desc>&#60; dispatch DER/DR</desc>
			
			
			<rect x="0" y="1536.55" width="126" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="-1587.72" y="66.6" transform="rotate(-90)" className="st31" langid="1033">&#60; dispatch DER/DR</text>		</G>
		<G id="shape1495-916" mid="1495" groupcontext="shape" layermember="7" transform="translate(1074.33,-741.375)">
			<title></title>
			<path d="M0 1548 L0 1884.37 L-166.61 1884.37 A3 3 -180 0 0 -172.61 1884.37 L-182.71 1884.37 A3 3 -180 0 0 -188.71 1884.37
						 L-252 1884.37 L-252 1803.37" className="st65"/>
		</G>
		<G id="shape1496-923" mid="1496" groupcontext="shape" layermember="7" transform="translate(822.33,-405)">
			<title></title>
			<path d="M0 1548 L-13.11 1548 A3 3 -180 1 0 -19.11 1548 L-29.22 1548 A3 3 -180 1 0 -35.22 1548 L-202.11 1548 A3 3 -180
						 1 0 -208.11 1548 L-218.22 1548 A3 3 -180 1 0 -224.22 1548 L-269.55 1548 L-269.55 1479.06" className="st66"/>
		</G>
		<G id="shape1497-928" mid="1497" groupcontext="shape" layermember="7" transform="translate(1009.17,-494)">
			<title></title>
			<desc>&#60; sell and distribute retail electricity</desc>
			
			
			<rect x="0" y="1528" width="124.83" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="-1585.98" y="58.82" transform="rotate(-90)" className="st63" langid="1033">&#60; sell and distribute <tspan
						x="-1576.07" dy="1.2em" className="st16">retail electricity</tspan></text>		</G>
		<G id="shape1501-932" mid="1501" groupcontext="shape" layermember="7" transform="translate(904.725,-747)">
			<title></title>
			<path d="M0 1548 L0 1908.93 L-13.11 1908.93 A3 3 -180 0 0 -19.11 1908.93 L-95.5 1908.93 A3 3 -180 0 0 -101.5 1908.93
						 L-111.61 1908.93 A3 3 -180 0 0 -117.61 1908.93 L-284.5 1908.93 A3 3 -180 0 0 -290.5 1908.93 L-300.61 1908.93
						 A3 3 -180 0 0 -306.61 1908.93 L-397 1908.93 L-397 1795.5 L-380.11 1795.5" className="st60"/>
		</G>
		<G id="shape1502-939" mid="1502" groupcontext="shape" layermember="7" transform="translate(904.725,-510.75)">
			<title></title>
			<path d="M0 1554.75 L0 1559.25 L-13.11 1559.25 A3 3 -180 0 0 -19.11 1559.25 L-34.06 1559.25" className="st62"/>
		</G>
		<G id="shape1504-944" mid="1504" groupcontext="shape" layermember="3" transform="translate(888.615,-747)">
			<title></title>
			<path d="M0 1548 L-0 1926.31 L-79.4 1926.31 A3 3 -180 0 0 -85.4 1926.31 L-95.5 1926.31 A3 3 -180 0 0 -101.5 1926.31 L-268.4
						 1926.31 A3 3 -180 0 0 -274.4 1926.31 L-284.51 1926.31 A3 3 -180 0 0 -290.5 1926.31 L-402.62 1926.31 L-402.62
						 1782 L-364 1782" className="st48"/>
		</G>
		<G id="shape1505-951" mid="1505" groupcontext="shape" layermember="7" transform="translate(846,-486)">
			<title></title>
			<desc>&#60; sell and distribute retail electricity</desc>
			
			
			<rect x="0" y="1521.1" width="117" height="26.8956" className="st11" style={{fill: 'inherit'}} />
			<text x="-1582.53" y="54.9" transform="rotate(-90)" className="st63" langid="1033">&#60; sell and distribute <tspan
						x="-1572.63" dy="1.2em" className="st16">retail electricity</tspan></text>		</G>
		<G id="shape1506-955" mid="1506" groupcontext="shape" layermember="3" transform="translate(888.637,-515.25)">
			<title></title>
			<path d="M-0.02 1541.25 L-6.77 1541.25 L-6.77 1536.75 L-17.98 1536.75" className="st47"/>
		</G>
		<G id="shape1507-960" mid="1507" groupcontext="shape" layermember="3" transform="translate(856.17,-681.55)">
			<title></title>
			<desc>&#60; dispatch DER/DR</desc>
			
			
			<rect x="0" y="1536.55" width="61.83" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="-1567.22" y="27.32" transform="rotate(-90)" className="st31" langid="1033">&#60; dispatch <tspan
						x="-1561.42" dy="1.2em" className="st16">DER</tspan>/DR</text>		</G>
		<G id="shape1508-964" mid="1508" groupcontext="shape" layermember="4" transform="translate(1074.33,-914.625)">
			<title></title>
			<path d="M-0 1536.3 L-0 1535.94 L-0 1499.62 L-68.81 1499.62 A3 3 -180 0 0 -74.81 1499.62 L-81.56 1499.62 A3 3 -180 1
						 0 -87.56 1499.62 L-97.86 1499.62 A3 3 -180 0 0 -103.86 1499.62 L-219.93 1499.62 A3 3 -180 0 0 -225.93 1499.62
						 L-234.33 1499.62 A3 3 -180 0 0 -240.33 1499.62 L-290.34 1499.62" className="st67"/>
		</G>
		<G id="shape1509-972" mid="1509" groupcontext="shape" layermember="4" transform="translate(860.67,-949.289)">
			<title></title>
			<desc>coordinate capability &#38; limits &#62;</desc>
			
			
			<rect x="0" y="1519.59" width="108" height="28.4103" className="st11" style={{fill: 'inherit'}} />
			<text x="27.49" y="1530.2" className="st37" langid="1033">coordinate <tspan
						x="6.12" dy="1.2em" className="st16">capability </tspan>&#38; limits &#62;</text>		</G>
		<G id="shape1510-976" mid="1510" groupcontext="shape" layermember="0" transform="translate(144,-1206)" label="Federal Columbia River Power System" description="Located on the mainstem Columbia River and in several of its major tributaries, the Federal Columbia River Power System (FCRPS) comprises 33 hydroelectric projects in the Columbia River Basin and provides about one third of the electricity used in the Pacific Northwest. The Bureau of Reclamation (Reclamation) and the U.S. Army Corps of Engineers (Corps) planned, designed, constructed; and own and operate the federal water projects in the Pacific Northwest. The Bonneville Power Administration (BPA) markets the power generated from the federal projects and distributes power from federal and non-federal projects through its transmission system. The revenues collected cover the cost of operating and maintaining the projects. 
Reference:
U.S. Bureau of Reclamation, &quot;Federal Columbia River Power System&quot;, 2019, [Online]. Available: https://www.usbr.gov/pn/fcrps/index.html. [Accessed: 06-Jan-2020]." >
			<title>Federal Columbia River Power System</title>
			<desc>Federal Columbia River Power System</desc>
			
				
			
			
			
			<G id="shadow1510-977" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="27.99" y="1510.2" className="st15" langid="1033">Federal <tspan
							x="7.32" dy="1.2em" className="st16">Columbia River </tspan><tspan x="9.65" dy="1.2em" className="st16">Power System</tspan></text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="27.99" y="1510.2" className="st18" langid="1033">Federal <tspan
						x="7.32" dy="1.2em" className="st16">Columbia River </tspan><tspan x="9.65" dy="1.2em" className="st16">Power System</tspan></text>		</G>
		<G id="shape1511-988" mid="1511" groupcontext="shape" layermember="1" transform="translate(240.66,-1219.63)">
			<title></title>
			<desc>priorities and constraints &#62;</desc>
			
			
			<path d="M0 1548.12 L13.5 1548.12 L13.5 1565.87 L33.45 1565.87 A3 3 0 0 1 39.45 1565.87 L81.78 1565.87 A3 3 0 0 1 87.78
						 1565.87 L192.12 1565.87 A3 3 0 0 1 198.12 1565.87 L356.76 1565.87" className="st19"/>
			<rect rectcontext="textBkgnd" x="90.0691" y="1545.43" width="130.542" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="90.07" y="1556.23" className="st21" langid="1033">priorities and constraints &#62;</text>		</G>
		<G id="shape1512-997" mid="1512" groupcontext="shape" layermember="1" transform="translate(526.313,-1201.75)">
			<title></title>
			<path d="M8.06 1548 L8.06 1561.5 L9.94 1561.5 L9.94 1600" className="st68"/>
		</G>
		<G id="shape1513-1002" mid="1513" groupcontext="shape" layermember="0" transform="translate(1404,-304)">
			<title></title>
			<desc>Title: Pacific Northwest Industry Model (as built)</desc>
			
				
			
			
			
			<G id="shadow1513-1003" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1528" width="306" height="20" className="st13" style={{fill: 'inherit'}} />
				<text x="4" y="1541.6" className="st40" langid="1033">Title: Pacific Northwest Industry Model (as built)</text>			</G>
			<rect x="0" y="1528" width="306" height="20" className="st69" style={{fill: 'inherit'}} />
			<text x="4" y="1541.6" className="st12" langid="1033">Title: Pacific Northwest Industry Model (as built)</text>		</G>
		<G id="shape1514-1010" mid="1514" groupcontext="shape" layermember="0" transform="translate(1404,-284)">
			<title></title>
			<desc>Drawn by: S. Pal</desc>
			
				
			
			
			
			<G id="shadow1514-1011" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1528" width="122.938" height="20" className="st13" style={{fill: 'inherit'}} />
				<text x="4" y="1541.6" className="st40" langid="1033">Drawn by: S. Pal</text>			</G>
			<rect x="0" y="1528" width="122.938" height="20" className="st69" style={{fill: 'inherit'}} />
			<text x="4" y="1541.6" className="st12" langid="1033">Drawn by: S. Pal</text>		</G>
		<G id="shape1515-1018" mid="1515" groupcontext="shape" layermember="0" transform="translate(1526.94,-284)">
			<title></title>
			<desc>Version: 0.5</desc>
			
				
			
			
			
			<G id="shadow1515-1019" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1528" width="183.062" height="20" className="st13" style={{fill: 'inherit'}} />
				<text x="4" y="1541.6" className="st40" langid="1033">Version: 0.5</text>			</G>
			<rect x="0" y="1528" width="183.062" height="20" className="st69" style={{fill: 'inherit'}} />
			<text x="4" y="1541.6" className="st12" langid="1033">Version: 0.5</text>		</G>
		<G id="shape1516-1026" mid="1516" groupcontext="shape" layermember="0" transform="translate(1404,-266)">
			<title></title>
			<desc>Date: 03 â€“ Jun â€“ 2018</desc>
			
				
			
			
			
			<G id="shadow1516-1027" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1530" width="306" height="18" className="st13" style={{fill: 'inherit'}} />
				<text x="4" y="1542.6" className="st40" langid="1033">Date: 03 â€“ Jun â€“ 2018</text>			</G>
			<rect x="0" y="1530" width="306" height="18" className="st69" style={{fill: 'inherit'}} />
			<text x="4" y="1542.6" className="st12" langid="1033">Date: 03 â€“ Jun â€“ 2018</text>		</G>
		<G id="shape1517-1034" mid="1517" groupcontext="shape" layermember="0" transform="translate(1404,-248)">
			<title></title>
			<desc>Project: GMLC 1.2.1 Grid Architecture</desc>
			
				
			
			
			
			<G id="shadow1517-1035" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1530" width="306" height="18" className="st13" style={{fill: 'inherit'}} />
				<text x="4" y="1542.6" className="st40" langid="1033">Project: GMLC 1.2.1 Grid Architecture</text>			</G>
			<rect x="0" y="1530" width="306" height="18" className="st69" style={{fill: 'inherit'}} />
			<text x="4" y="1542.6" className="st12" langid="1033">Project: GMLC 1.2.1 Grid Architecture</text>		</G>
		<G id="shape1518-1042" mid="1518" groupcontext="shape" layermember="1" transform="translate(341.55,-972)">
			<title></title>
			<desc>regulates &#62;</desc>
			
			
			<path d="M0 1548 L0 1576 L46.32 1576 L46.32 1950.97 L256.56 1950.97 A3 3 0 0 1 262.56 1950.97 L309.12 1950.97 A3 3 0
						 0 1 315.12 1950.97 L477.78 1950.97 A3 3 0 1 1 483.78 1950.97 L544.07 1950.97 A3 3 0 0 1 550.07 1950.97 L560.17
						 1950.97 A3 3 0 0 1 566.17 1950.97 L639.78 1950.97 A3 3 0 0 1 645.78 1950.97 L729.78 1950.97 A3 3 0 0 1 735.78
						 1950.97 L762 1950.97 A3 3 0 1 1 768 1950.97 L814.23 1950.97 L814.23 1989" className="st19"/>
			<rect rectcontext="textBkgnd" x="153.459" y="1930.05" width="53.9827" height="14.4001" className="st41" style={{fill: 'inherit'}} />
			<text x="153.46" y="1940.85" className="st21" langid="1033">regulates &#62;</text>		</G>
		<G id="shape1519-1051" mid="1519" groupcontext="shape" layermember="3" transform="translate(1272.33,-960.429)">
			<title></title>
			<desc>coordinate power transfer with EIM entity BA &#62;</desc>
			
			
			<path d="M11.7 1548 L12.06 1548 L24.05 1548 A3 3 0 0 1 30.05 1548 L77.67 1548 L77.67 2004.43 L44.67 2004.43 A3 3 -180
						 0 0 38.67 2004.43 L16.5 2004.43 A3 3 -180 0 0 10.5 2004.43 L-36 2004.43" className="st70"/>
			<rect rectcontext="textBkgnd" x="-1969.51" y="61.4702" width="230.884" height="14.4001" transform="rotate(-90)"
					className="st41" style={{fill: 'inherit'}} />
			<text x="-1969.51" y="72.27" transform="rotate(-90)" className="st31" langid="1033">coordinate power transfer with EIM entity BA &#62;</text>		</G>
		<G id="shape1520-1062" mid="1520" groupcontext="shape" layermember="3" transform="translate(1224,-840.857)">
			<title></title>
			<path d="M0 1559.7 L0 1560.06 L0 1700.36 L-25.56 1700.36 L-25.56 1713.86" className="st70"/>
		</G>
		<G id="shape1521-1069" mid="1521" groupcontext="shape" layermember="3" transform="translate(1148.63,-750.275)">
			<title></title>
			<desc>&#60; coordinate transfers</desc>
			
			
			<rect x="0" y="1536.55" width="132.75" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="-1596.21" y="69.98" transform="rotate(-90)" className="st31" langid="1033">&#60; coordinate transfers</text>		</G>
		<G id="shape1526-1072" mid="1526" groupcontext="shape" layermember="1;2;3;4;5;6;7;0" transform="translate(1404,-432)">
			<title></title>
			<rect x="0" y="1315.76" width="132.75" height="232.245" className="st71"/>
		</G>
		<G id="shape1527-1074" mid="1527" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1410.75,-557.228)">
			<title></title>
			<desc>Entity Class</desc>
			
			
			<path d="M72 1521.75 L0 1521.75 L0 1548 L72 1548 L72 1521.75 Z" className="st72"/>
			<text x="9.6" y="1537.87" className="st73" langid="1033">Entity Class</text>		</G>
		<G id="group1528-1077" transform="translate(1410.75,-622.805)" mid="1528" groupcontext="group"
				layermember="1;2;3;4;5;6;7;0">
			<title></title>
			<G id="shape1529-1078" mid="1529" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(17.3171,-3.5974)">
				<title></title>
				<path d="M0 1548 L23.57 1548" className="st74"/>
			</G>
			<G id="shape1530-1081" mid="1530" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(5.4116,0)">
				<title></title>
				<path d="M0 1540.81 L0 1548" className="st74"/>
			</G>
			<G id="shape1531-1084" mid="1531" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(5.4116,0)">
				<title></title>
				<path d="M0 1548 L0 1540.81" className="st74"/>
			</G>
			<G id="shape1532-1087" mid="1532" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(-4.996E-015,-3.5974)">
				<title></title>
				<path d="M10.82 1548 L0 1548" className="st74"/>
			</G>
			<G id="shape1533-1090" mid="1533" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(-4.996E-015,-3.5974)">
				<title></title>
				<path d="M0 1548 L10.82 1548" className="st74"/>
			</G>
			<G id="shape1534-1093" mid="1534" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(10.8232,-1.07922)">
				<title></title>
				<ellipse cx="2.88618" cy="1545.12" rx="2.88618" ry="2.87792" className="st75"/>
				<ellipse cx="2.88618" cy="1545.12" rx="2.88618" ry="2.87792" className="st74"/>
			</G>
		</G>
		<G id="group1535-1096" transform="translate(1410.75,-610.332)" mid="1535" groupcontext="group"
				layermember="1;2;3;4;5;6;7;0">
			<title></title>
			<G id="shape1536-1097" mid="1536" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(17.3171,-3.47749)">
				<title></title>
				<path d="M0 1548 L18.76 1548" className="st74"/>
			</G>
			<G id="shape1537-1100" mid="1537" groupcontext="shape" layermember="1;2;3;4;5;6;7;0">
				<title></title>
				<path d="M10.82 1544.52 L0 1548" className="st74"/>
			</G>
			<G id="shape1538-1103" mid="1538" groupcontext="shape" layermember="1;2;3;4;5;6;7;0">
				<title></title>
				<path d="M0 1548 L10.82 1544.52" className="st74"/>
			</G>
			<G id="shape1539-1106" mid="1539" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M10.82 1548 L0 1544.4" className="st74"/>
			</G>
			<G id="shape1540-1109" mid="1540" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M0 1544.4 L10.82 1548" className="st74"/>
			</G>
			<G id="shape1541-1112" mid="1541" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M10.82 1548 L0 1548" className="st74"/>
			</G>
			<G id="shape1542-1115" mid="1542" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(2.69784E-014,-3.47749)">
				<title></title>
				<path d="M0 1548 L10.82 1548" className="st74"/>
			</G>
			<G id="shape1543-1118" mid="1543" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(10.8232,-0.959308)">
				<title></title>
				<ellipse cx="2.88618" cy="1545.12" rx="2.88618" ry="2.87792" className="st75"/>
				<ellipse cx="2.88618" cy="1545.12" rx="2.88618" ry="2.87792" className="st74"/>
			</G>
		</G>
		<G id="group1544-1121" transform="translate(1410.65,-635.399)" mid="1544" groupcontext="group"
				layermember="1;2;3;4;5;6;7;0">
			<title></title>
			<G id="shape1545-1122" mid="1545" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0,-3.5974)">
				<title></title>
				<path d="M0 1548 L36.2 1548" className="st74"/>
			</G>
			<G id="shape1546-1125" mid="1546" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(10.9435,0)">
				<title></title>
				<path d="M0 1540.93 L0 1548" className="st74"/>
			</G>
			<G id="shape1547-1128" mid="1547" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(10.9435,0)">
				<title></title>
				<path d="M0 1548 L0 1540.93" className="st74"/>
			</G>
			<G id="shape1548-1131" mid="1548" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(14.1904,0)">
				<title></title>
				<path d="M0 1540.93 L0 1548" className="st74"/>
			</G>
			<G id="shape1549-1134" mid="1549" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(14.1904,0)">
				<title></title>
				<path d="M0 1548 L0 1540.93" className="st74"/>
			</G>
		</G>
		<G id="group1550-1137" transform="translate(1410.75,-597.858)" mid="1550" groupcontext="group"
				layermember="1;2;3;4;5;6;7;0">
			<title></title>
			<G id="shape1551-1138" mid="1551" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(14.25,0)">
				<title></title>
				<path d="M0 1548 L0 1540.93" className="st74"/>
			</G>
			<G id="shape1552-1141" mid="1552" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0,-3.47749)">
				<title></title>
				<path d="M0 1548 L22.97 1548" className="st74"/>
			</G>
			<G id="shape1553-1144" mid="1553" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0.120258,0)">
				<title></title>
				<path d="M10.82 1544.52 L0 1548" className="st74"/>
			</G>
			<G id="shape1554-1147" mid="1554" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0.120258,0)">
				<title></title>
				<path d="M0 1548 L10.82 1544.52" className="st74"/>
			</G>
			<G id="shape1555-1150" mid="1555" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0.120258,-3.47749)">
				<title></title>
				<path d="M10.82 1548 L0 1544.4" className="st74"/>
			</G>
			<G id="shape1556-1153" mid="1556" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0.120258,-3.47749)">
				<title></title>
				<path d="M0 1544.4 L10.82 1548" className="st74"/>
			</G>
		</G>
		<G id="shape1557-1156" mid="1557" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1460.44,-632.361)">
			<title></title>
			<desc>only 1</desc>
			
			
			<rect x="0" y="1533.63" width="44.4643" height="14.375" className="st76" style={{fill: 'inherit'}} />
			<text x="4" y="1543.81" className="st73" langid="1033">only 1</text>		</G>
		<G id="shape1558-1159" mid="1558" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1460.44,-617.25)">
			<title></title>
			<desc>zero or 1</desc>
			
			
			<rect x="0" y="1533.63" width="57" height="14.375" className="st76" style={{fill: 'inherit'}} />
			<text x="4" y="1543.81" className="st73" langid="1033">zero or 1</text>		</G>
		<G id="shape1559-1162" mid="1559" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1460.44,-606.682)">
			<title></title>
			<desc>zero or more</desc>
			
			
			<rect x="0" y="1533.63" width="79.5" height="14.375" className="st76" style={{fill: 'inherit'}} />
			<text x="4" y="1543.81" className="st73" langid="1033">zero or more</text>		</G>
		<G id="shape1560-1165" mid="1560" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1460.44,-594.208)">
			<title></title>
			<desc>1 or more</desc>
			
			
			<rect x="0" y="1533.63" width="63.75" height="14.375" className="st76" style={{fill: 'inherit'}} />
			<text x="4" y="1543.81" className="st73" langid="1033">1 or more</text>		</G>
		<G id="shape1561-1168" mid="1561" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
				transform="translate(1453.74,-646)">
			<title></title>
			<desc>Key</desc>
			
			
			<rect x="0" y="1528" width="49.4891" height="20" className="st76" style={{fill: 'inherit'}} />
			<text x="14.41" y="1541.6" className="st18" langid="1033"><tspan className="st77">Key</tspan></text>		</G>
		<G id="group1562-1172" transform="translate(1408.91,-432)" mid="1562" groupcontext="group"
				layermember="1;2;3;4;5;6;7;0">
			<title></title>
			<G id="shape1563-1173" mid="1563" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(27.9643,-98.8929)">
				<title></title>
				<path d="M0 1548 L53.46 1548" className="st78"/>
			</G>
			<G id="shape1564-1182" mid="1564" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0.857143,-89.1429)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">A</text>			</G>
			<G id="shape1565-1185" mid="1565" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(96,-89.1429)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">B</text>			</G>
			<G id="shape1566-1188" mid="1566" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(41.1429,-96)">
				<title></title>
				<desc>relation&#62;</desc>
				
				
				<rect x="0" y="1532.43" width="39.3036" height="15.5714" className="st76" style={{fill: 'inherit'}} />
				<text x="4.2" y="1542.61" className="st80" langid="1033">relation&#62;</text>			</G>
			<G id="shape1567-1191" mid="1567" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(24.75,-77.25)">
				<title></title>
				<desc>A acts on or for B</desc>
				
				
				<rect x="0" y="1534.36" width="77.8214" height="13.6429" className="st76" style={{fill: 'inherit'}} />
				<text x="8.01" y="1543.58" className="st80" langid="1033">A acts on or for B</text>			</G>
			<G id="shape1568-1194" mid="1568" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(27.1071,-59.4643)">
				<title></title>
				<path d="M0 1548 L53.46 1548" className="st78"/>
			</G>
			<G id="shape1569-1201" mid="1569" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(0,-49.7143)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">A</text>			</G>
			<G id="shape1570-1204" mid="1570" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(95.1429,-49.7143)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">B</text>			</G>
			<G id="shape1571-1207" mid="1571" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(40.2857,-56.5714)">
				<title></title>
				<desc>&#60;relation</desc>
				
				
				<rect x="0" y="1532.43" width="39.3036" height="15.5714" className="st76" style={{fill: 'inherit'}} />
				<text x="4.2" y="1542.61" className="st80" langid="1033">&#60;relation</text>			</G>
			<G id="shape1572-1210" mid="1572" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(24,-40.5)">
				<title></title>
				<desc>B acts on or for A</desc>
				
				
				<rect x="0" y="1534.36" width="77.8214" height="13.6429" className="st76" style={{fill: 'inherit'}} />
				<text x="8.01" y="1543.58" className="st80" langid="1033">B acts on or for A</text>			</G>
			<G id="shape1573-1213" mid="1573" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(27.1071,-21.75)">
				<title></title>
				<path d="M0 1548 L53.46 1548" className="st78"/>
			</G>
			<G id="shape1574-1220" mid="1574" groupcontext="shape" layermember="1;2;3;4;5;6;7;0" transform="translate(0,-12)">
				<title></title>
				<desc>A</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">A</text>			</G>
			<G id="shape1575-1223" mid="1575" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(95.1429,-12)">
				<title></title>
				<desc>B</desc>
				
				
				<path d="M26.94 1529.73 L0 1529.73 L0 1548 L26.94 1548 L26.94 1529.73 Z" className="st72"/>
				<text x="10.13" y="1541.87" className="st73" langid="1033">B</text>			</G>
			<G id="shape1576-1226" mid="1576" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(37.7045,-18.1364)">
				<title></title>
				<desc>&#60;relation&#62;</desc>
				
				
				<rect x="0" y="1532.43" width="44.4643" height="15.5714" className="st76" style={{fill: 'inherit'}} />
				<text x="4.44" y="1542.61" className="st80" langid="1033">&#60;relation&#62;</text>			</G>
			<G id="shape1577-1229" mid="1577" groupcontext="shape" layermember="1;2;3;4;5;6;7;0"
					transform="translate(23.25,0)">
				<title></title>
				<desc>bilateral relation</desc>
				
				
				<rect x="0" y="1534.36" width="77.8214" height="13.6429" className="st76" style={{fill: 'inherit'}} />
				<text x="10.67" y="1543.58" className="st80" langid="1033">bilateral relation</text>			</G>
		</G>
		<G id="shape1578-1232" mid="1578" groupcontext="shape" layermember="0" transform="translate(72,-558)" label="WECC" description="The Western Electricity Coordinating Council (WECC) is a not-for-profit organization that works to effectively and efficiently mitigate risks to the reliability and security of the Western Interconnection's Bulk Power System. WECC is the Regional Reliability Entity that operates under a Federal Energy Regulatory Commission (FERC) approved delegation agreement with the North American Electric Reliability Corporation (NERC) and in accordance with WECC's Bylaws. It is responsible for compliance monitoring and enforcement, and oversees reliability planning and assessments. In addition, WECC provides an environment for the development of Reliability Standards and the coordination of the operating and planning activities of its members. 
Reference:
WECC, &quot;About WECC&quot;, 2015, [Online]. Available: https://www.wecc.org/Pages/AboutWECC.aspx. [Accessed: 06-Jan-2020]." >
			<title>Western Electricity Coordinating Council</title>
			<desc>WECC</desc>
			
				
			
			
			
			<G id="shadow1578-1233" groupcontext="shadow" shadowoffsetx="0.345598" shadowoffsety="-1.97279" shadowtype="1"
					transform="matrix(1,0,0,1,0.345598,1.97279)" className="st1">
				<rect x="0" y="1494" width="96.66" height="54" className="st13" style={{fill: 'inherit'}} />
				<text x="30" y="1524.6" className="st15" langid="1033">WECC</text>			</G>
			<rect x="0" y="1494" width="96.66" height="54" className="st17" style={{fill: 'inherit'}} />
			<text x="30" y="1524.6" className="st18" langid="1033">WECC</text>		</G>
		<G id="shape1579-1240" mid="1579" groupcontext="shape" layermember="6" transform="translate(111.33,-612)">
			<title></title>
			<path d="M9 1548 L9 1404" className="st51"/>
		</G>
		<G id="shape1580-1247" mid="1580" groupcontext="shape" layermember="6" transform="translate(54,-674)">
			<title></title>
			<desc>&#60; delegates compliance monitoring and enforcement</desc>
			
			
			<rect x="0" y="1528" width="132.75" height="20" className="st11" style={{fill: 'inherit'}} />
			<text x="-1595.19" y="62.78" transform="rotate(-90)" className="st53" langid="1033">&#60; delegates compliance <tspan
						x="-1575.64" dy="1.2em" className="st16">monitoring and </tspan><tspan x="-1569.69" dy="1.2em" className="st16">enforcement</tspan></text>		</G>
		<G id="shape1581-1252" mid="1581" groupcontext="shape" layermember="1" transform="translate(1161.94,-567)">
			<title></title>
			<path d="M-6.16 1548 L-11.84 1548 L-11.84 1494" className="st68"/>
		</G>
		<G id="shape1582-1257" mid="1582" groupcontext="shape" layermember="5" transform="translate(694.08,-1201.75)">
			<title></title>
			<path d="M0 1548 L22.47 1548 A3 3 0 0 1 28.47 1548 L142.92 1548 L142.92 2148.55 L191.54 2148.55 A3 3 0 0 1 197.54 2148.55
						 L207.64 2148.55 A3 3 0 0 1 213.64 2148.55 L258.03 2148.55 L258.03 2113.81" className="st38"/>
		</G>
		<G id="shape1583-1264" mid="1583" groupcontext="shape" layermember="5" transform="translate(806.085,-756)">
			<title></title>
			<desc>&#60; is a type of</desc>
			
			
			<rect x="0" y="1521.1" width="79.5" height="26.8956" className="st11" style={{fill: 'inherit'}} />
			<text x="-1565.42" y="43.35" transform="rotate(-90)" className="st34" langid="1033">&#60; is a type of</text>		</G>
		<G id="shape1589-1267" mid="1589" groupcontext="shape" layermember="4" transform="translate(1054.89,-1197)">
			<title></title>
			<path d="M0 1548 L84.51 1548 L84.51 1816.87 L51.66 1816.87 L51.66 1818.31" className="st50"/>
		</G>
		<G id="shape1590-1272" mid="1590" groupcontext="shape" layermember="4" transform="translate(989.772,-1064.1)">
			<title></title>
			<path d="M0 1548 L0 1693.01 L-22.59 1693.01 L-22.59 1718.96" className="st50"/>
		</G>
		<G id="shape1591-1277" mid="1591" groupcontext="shape" layermember="4" transform="translate(1068.91,-970.714)">
			<title></title>
			<path d="M0 1555.71 L18.53 1556.16 A3 3 0 0 1 24.53 1556.31 L67.49 1557.34 A3 3 0 0 1 73.49 1557.48 L85.76 1557.78 A3
						 3 0 1 1 91.76 1557.92 L106.76 1558.29" className="st81"/>
		</G>
		<G id="shape1592-1283" mid="1592" groupcontext="shape" layermember="4" transform="translate(1097.3,-962.316)">
			<title></title>
			<path d="M0 1548 L-3.86 1548 A3 3 -180 1 0 -9.86 1548 L-26.3 1548 L-26.3 1468.57" className="st81"/>
		</G>
		<G id="shape1593-1288" mid="1593" groupcontext="shape" layermember="3" transform="translate(848.34,-921.275)">
			<title></title>
			<desc>dispatch, control &#38; balance &#62;</desc>
			
			
			<rect x="0" y="1536.55" width="96.66" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="7.38" y="1538.68" className="st31" langid="1033">dispatch, control <tspan
						x="19.58" dy="1.2em" className="st16">&#38; </tspan>balance &#62;</text>		</G>
		<G id="shape1598-1292" mid="1598" groupcontext="shape" layermember="7" transform="translate(1272.33,-900.643)">
			<title></title>
			<path d="M0 1548 L13.5 1548 L13.5 2095.1 L-463.11 2095.1 A3 3 -180 0 0 -469.11 2095.1 L-482.22 2095.1 L-482.22 1962.64"
					className="st65"/>
		</G>
		<G id="shape1599-1299" mid="1599" groupcontext="shape" layermember="7" transform="translate(601.11,-486)">
			<title></title>
			<path d="M0 1559.7 L0 1560.06 L0 1680.46 L13.11 1680.46 A3 3 0 0 1 19.11 1680.46 L197.8 1680.46" className="st82"/>
		</G>
		<G id="shape1601-1305" mid="1601" groupcontext="shape" layermember="7" transform="translate(970.469,-360)">
			<title></title>
			<desc>&#60; sell and distribute retail electricity</desc>
			
			
			<rect x="0" y="1536.55" width="183.062" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="4.12" y="1545.88" className="st63" langid="1033">&#60; sell and distribute retail electricity</text>		</G>
		<G id="shape1604-1308" mid="1604" groupcontext="shape" layermember="3" transform="translate(1272.33,-929.25)">
			<title></title>
			<path d="M0 1548 L24.04 1548 A3 3 0 0 1 30.04 1548 L41.67 1548 L41.67 2153.25 L-466.11 2153.25 L-466.11 1991.25"
					className="st29"/>
		</G>
		<G id="shape1605-1315" mid="1605" groupcontext="shape" layermember="3" transform="translate(617.22,-486)">
			<title></title>
			<path d="M0 1559.7 L0 1560.06 L0 1710 L189 1710" className="st83"/>
		</G>
		<G id="shape1606-1320" mid="1606" groupcontext="shape" layermember="3" transform="translate(1080,-330.55)">
			<title></title>
			<desc>&#60; dispatch DER/DR</desc>
			
			
			<rect x="0" y="1536.55" width="126" height="11.45" className="st11" style={{fill: 'inherit'}} />
			<text x="17.55" y="1545.88" className="st31" langid="1033">&#60; dispatch DER/DR</text>		</G>
	</G>
</svg>

            </div>
        );
    }
}
